import React, { useContext } from "react";

import { Header } from "./Header";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";

import { useTranslation } from "react-i18next";

import ClipImageStep1 from "./assets/images/clip_image_step1.svg";
import Image1Step1 from "./assets/images/image1_step1.svg";
import Image2Step1 from "./assets/images/image2_step1.svg";
import Image1Step2 from "./assets/images/image1_step2.svg";
import OpacityCounter from "./assets/images/opacity_counter.svg";
import ClipImageStep3 from "./assets/images/clip_image_step3.svg";
import Image1Step3 from "./assets/images/image1_step3.svg";
import Image2Step3 from "./assets/images/image2_step3.svg";
import BirdGoelys from "./assets/images/bird_goelys.svg";

import "./Home.css";

export default function Home(props: any) {
  return (
    <>
      <Header user={props.user} />
      <PresentationAnimationSection />
      <AdvantagesSection />
      <ContactSection />
    </>
  );
}

function PresentationAnimationSection() {
  return (
    <section className="section_animation">
      <div className="main_container">
        <TitleAnimation />
        <Animation />
      </div>
    </section>
  );
}

function TitleAnimation() {
  return (
    <>
      <div className="opacity"></div>
      <h4 className="title_animation mt-4">
        <span className="title_animation">
          La Solution Connectée pour commander
        </span>
        <span className="subtitle_animation d-none d-md-block">
          en 3 étapes <span className="highlight_title_animation">simples</span>{" "}
          et <span className="highlight_title_animation">rapides</span>
        </span>
      </h4>
    </>
  );
}

function Animation() {
  return (
    <div className="div_animation mt-3">
      <div className="div_terrasse">
        <h5 className="title_terrasse">En salle / En terrasse</h5>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1805.43 990.51">
          <g id="Calque_1" data-name="Calque 1">
            <g id="_Layer1_" data-name="&lt;Layer1&gt;">
              <g id="Terrasse">
                <path
                  id="t_Fond"
                  className="cls-1"
                  d="M1525.43,104.58c-163.15-7.19-322.75-187-538.48-58.26L984.26,48C911.71,92,835.68,145.47,755.86,209.61Q737.95,224,720.74,236.37C548.8,360.19,427.15,341.18,310.79,361.78c-41.93,7.43-83.18,20-125.83,46.24-37.73,23.22-66.76,49.59-88.68,78-33.91,44-50.8,92.74-56.5,142.09-.66,5.58-1.15,11.18-1.53,16.77-2.37,36,.83,71.94,7.33,106.35Q48.4,766.16,52,780.64c3.25,13.19,6.91,26.06,10.86,38.5v0c.28.86.54,1.71.83,2.55q1.23,3.85,2.5,7.63c.36,1.08.71,2.15,1.07,3.2q3.58,10.51,7.36,20.53c3.64,9.69,7.38,19,11.15,27.91h0q1.41,3.38,2.84,6.64c25.43,58.6,50.8,97.11,50.8,97.11l1666,1.6V60C1720.47,79.24,1649.71,110.06,1525.43,104.58Z"
                />
                <path
                  id="t_Table_fond2"
                  className="cls-2"
                  d="M993.67,706.24H734.39l-2.72-19.81a4.17,4.17,0,0,0-.36-1.25c1.68-30.42,8.54-55.34,9.75-73.06,2.81-9.59,1-15.13-1.61-18.29l2.15.33c-10.81-9.53-16.14-74.07-16.57-79.62a21.77,21.77,0,0,0-.38-2.73c-.95-6.08-3.92-20.63-11-26.41L684,487.51s-11.44,5.45-19.91,30.57h0a18.9,18.9,0,0,0-4,9.47c-1.38,11.26,5.74,15.6,5.75,15.61,0-.44-.07-.88-.11-1.32,0,.44,0,.88.11,1.32h0c1.09,12.68,4.33,27.63,10.07,28.24,0,0,2.47.11,6.1-.13a51.22,51.22,0,0,1-1.79,14.48l-1.94.36,0,0a9,9,0,0,0-1.19.25l-.11,0a7.66,7.66,0,0,0-.94.25c-1.82.46-3.82,1.24-5.54,1.82,0,0-19.12,5.22-46.86,50.77h-4.12c-.53-.23-1.06-.47-1.58-.73a16.38,16.38,0,0,0-1.53-.65l.2-4.57.57-12.91.27-6.18h.86l-.55-4.18H598.33l-.8,4.18h.86l.38,6.18.81,12.91.16,2.55a5.91,5.91,0,0,0-3.12,1.16,2.71,2.71,0,0,0-.7,2.24H586.6l.26-5.95.56-12.91.28-6.18h.85L588,610H568.59l-.8,4.18h.85l.39,6.18.8,12.91.37,5.81-2.53-.36a38.59,38.59,0,0,1-5.46-2.16c-4.71-2.36-17.29-3.93-20-1.41s2.83,12.73,14.3,13a72.51,72.51,0,0,1,9.27.77,281.47,281.47,0,0,0,30.3,11.85c5.54,1.76,11.33,3.4,16.86,4.64a86.5,86.5,0,0,0,14.35,2.15A81.64,81.64,0,0,0,642,659.45c2.8,1.09,5.81,2.22,8.94,3.33l-1.43,16.6c-.52,3.75-.75,14.69-.83,26.86H403.8c-1.45-10.21-3.77-22.75-4.24-27.92-.73-8.1-.43-17.79.16-27.51,7.64-2.55,14.9-5.4,20.41-7.68a84.68,84.68,0,0,0,16.45,9.35c.56,0,1.12-.06,1.7-.11h.07l1.66-.16.23,0,1.55-.19.44-.06,1.37-.2.68-.11,1.16-.19.91-.17.95-.18,1.12-.22.77-.16,1.29-.28.45-.09.1,0c1.3-.29,2.62-.6,4-.94l.23-.05c1.31-.34,2.64-.69,4-1.06l.29-.07c1.31-.37,2.63-.75,3.94-1.14l.29-.09c1.38-.41,2.75-.83,4.1-1.26a281.47,281.47,0,0,0,30.3-11.85,72.5,72.5,0,0,1,9.26-.77c11.48-.31,17-10.53,14.31-13.05s-15.25-.94-20,1.42a38.13,38.13,0,0,1-5.46,2.16c-16.39,2.37-29.05,3-37.42,3.81.59-1.72.51-3.2-.32-4-2.46-2.32-12.79-1.39-18.81.53C410.4,583.84,390,571.08,390,571.08a8.79,8.79,0,0,0-1.08-.45c13.49-9.71-4.94-10.08-.95-42.61,1.94-15.84-3-41.18-34.62-37.13s-41.57,35.12-35.2,48.93-9.17,17.14-14.06,32c-4.19,12.76-5.65,28.6-12.44,35.71C272.81,627.22,301.8,656,326.74,659a78.54,78.54,0,0,1-.24,7.87,27.56,27.56,0,0,1-.46,3.15c-1.75,9-7.59,24.38-11.31,36.19H297a11.48,11.48,0,0,0-11.45,11.45V974.17A11.48,11.48,0,0,0,297,985.62H993.67a11.48,11.48,0,0,0,11.45-11.45V717.69A11.48,11.48,0,0,0,993.67,706.24ZM401.43,626.56c1.35,1.49,2.71,2.9,4.06,4.25l-4.38.44C401.23,629.65,401.33,628.08,401.43,626.56Z"
                />
                <path
                  id="t_Table_fond1"
                  className="cls-2"
                  d="M1758.93,706.24H1575.28l-2.72-19.81a4.49,4.49,0,0,0-.36-1.25c1.68-30.42,8.54-55.34,9.75-73.06,2.81-9.59,1-15.13-1.61-18.29l2.15.33c-10.81-9.53-16.14-74.07-16.57-79.62a21.77,21.77,0,0,0-.38-2.73c-1-6.08-3.92-20.63-11-26.41l-29.7,2.11S1513.43,493,1505,518.08h0a19,19,0,0,0-4,9.47c-1.38,11.27,5.75,15.61,5.75,15.61,0-.44-.07-.88-.11-1.32,0,.44.05.88.11,1.32h0c1.1,12.68,4.33,27.63,10.07,28.24,0,0,2.47.11,6.1-.13a51.22,51.22,0,0,1-1.79,14.48l-1.94.36,0,0a9,9,0,0,0-1.19.25l-.1,0a7.36,7.36,0,0,0-.95.25c-1.82.46-3.83,1.24-5.54,1.82,0,0-19.12,5.22-46.86,50.77h-4.12c-.53-.23-1.06-.47-1.58-.73a16.38,16.38,0,0,0-1.53-.65l.2-4.57.57-12.91.27-6.18h.86l-.55-4.18h-19.42l-.8,4.18h.86l.38,6.18.81,12.91.16,2.55a5.91,5.91,0,0,0-3.12,1.16,2.71,2.71,0,0,0-.7,2.24h-9.32l.26-5.95.56-12.91.27-6.18h.86l-.54-4.18h-19.42l-.8,4.18h.85l.36,5.69a22.7,22.7,0,0,0-4.94,1.61,38,38,0,0,1-5.45,2.16c-16.39,2.37-29.06,3-37.43,3.81.6-1.72.51-3.2-.32-4-2.46-2.32-12.79-1.39-18.81.53-29.29-40.12-49.73-52.88-49.73-52.88a7.91,7.91,0,0,0-1.08-.45c13.49-9.71-4.93-10.08-1-42.61,1.94-15.84-3-41.18-34.62-37.13S1215,526,1221.37,539.82s-9.18,17.14-14.06,32c-4.2,12.76-5.66,28.6-12.45,35.71-18.79,19.69,10.2,48.48,35.14,51.5a78.63,78.63,0,0,1-.25,7.87,27.56,27.56,0,0,1-.46,3.15c-1.75,9-7.59,24.38-11.31,36.19H1111.89a11.08,11.08,0,0,0-11.05,11v257.3a11.08,11.08,0,0,0,11.05,11h647a11.08,11.08,0,0,0,11-11V717.28A11.08,11.08,0,0,0,1758.93,706.24Zm-357.59-72.4a72.68,72.68,0,0,1,9.27-.77h.1v.17l.37,5.81-2.54-.36a38.49,38.49,0,0,1-5.45-2.16,21.61,21.61,0,0,0-4.4-1.48Zm-96.66-7.28c1.36,1.49,2.71,2.9,4.07,4.25l-4.38.44C1304.48,629.65,1304.59,628.08,1304.68,626.56Zm185.69,52.82c-.52,3.75-.75,14.69-.83,26.86H1307.05c-1.45-10.21-3.76-22.75-4.24-27.92-.73-8.1-.43-17.79.17-27.51,7.63-2.55,14.89-5.4,20.41-7.68a84.35,84.35,0,0,0,16.45,9.35c.55,0,1.11-.06,1.69-.11h.07l1.67-.16.22,0L1345,652l.44-.06,1.37-.2.69-.11,1.15-.19.92-.17.94-.18,1.12-.22.77-.16,1.29-.28.45-.09.1,0c1.3-.29,2.62-.6,4-.94l.23-.05c1.32-.34,2.64-.69,4-1.06l.29-.07c1.32-.37,2.63-.75,3.94-1.14a2.46,2.46,0,0,0,.29-.09q2.07-.62,4.11-1.26c4.5-1.43,8.93-3,13-4.56a16.49,16.49,0,0,0,13.45,7,72.5,72.5,0,0,1,9.26.77A281.85,281.85,0,0,0,1437,660.77c5.55,1.76,11.34,3.4,16.87,4.64a86.55,86.55,0,0,0,14.34,2.15,81.48,81.48,0,0,0,14.65-8.11c2.8,1.09,5.81,2.22,8.93,3.33Z"
                />
                <path
                  id="t_Sol"
                  className="cls-3"
                  d="M0,987.49a3,3,0,0,0,3,3H1805.43v-6H3A3,3,0,0,0,0,987.49Z"
                />
                <path
                  id="t_Ecran_fond3"
                  className="cls-4"
                  d="M1525.43,104.58c-163.15-7.19-322.75-187-538.48-58.26L984.26,48v84.29c0,10.8,11.27,19.62,25,19.62h793.09V971.92a13.12,13.12,0,0,0,3,8.44V60C1720.47,79.24,1649.71,110.06,1525.43,104.58Z"
                />
                <g id="t_Ecran_fond2">
                  <rect
                    className="cls-4"
                    x="1065.84"
                    y="236.36"
                    width="669.13"
                    height="164.54"
                    rx="8.48"
                  />
                  <path
                    className="cls-2"
                    d="M1265.13,270.27h-144.8a8.18,8.18,0,1,0,0,16.36h144.8a8.18,8.18,0,0,0,0-16.36Z"
                  />
                  <path
                    className="cls-2"
                    d="M1265.13,310.45h-144.8a8.18,8.18,0,1,0,0,16.36h144.8a8.18,8.18,0,0,0,0-16.36Z"
                  />
                  <path
                    className="cls-2"
                    d="M1265.13,350.63h-144.8a8.18,8.18,0,1,0,0,16.36h144.8a8.18,8.18,0,0,0,0-16.36Z"
                  />
                  <path
                    className="cls-2"
                    d="M1482.56,270.27h-144.8a8.18,8.18,0,0,0,0,16.36h144.8a8.18,8.18,0,1,0,0-16.36Z"
                  />
                  <path
                    className="cls-2"
                    d="M1482.56,310.45h-144.8a8.18,8.18,0,0,0,0,16.36h144.8a8.18,8.18,0,1,0,0-16.36Z"
                  />
                  <path
                    className="cls-2"
                    d="M1482.56,350.63h-144.8a8.18,8.18,0,0,0,0,16.36h144.8a8.18,8.18,0,1,0,0-16.36Z"
                  />
                  <rect
                    className="cls-2"
                    x="1521.58"
                    y="270.27"
                    width="180.16"
                    height="96.73"
                    rx="12.67"
                  />
                </g>
                <path
                  id="t_Ecran_fond1"
                  className="cls-4"
                  d="M971.45,236.37H720.74C548.8,360.19,427.15,341.18,310.79,361.78v30.65a8.5,8.5,0,0,0,8.47,8.48H971.45a8.51,8.51,0,0,0,8.47-8.48V244.84A8.5,8.5,0,0,0,971.45,236.37Z"
                />
                <g id="t_Chaise_orange">
                  <path
                    className="cls-5"
                    d="M274.76,551.35c-.84-1.65-3.75-2.67-8.44-2.26-5.37.47-5.53,4.15-4.69,5.8.51,1,50.31,100,48.24,228.79a3.49,3.49,0,0,0,3.64,3.32h.05a3.5,3.5,0,0,0,3.69-3.23c1.1-68-7.53-129.88-18.91-167.65C286,575.16,274.89,551.6,274.76,551.35Z"
                  />
                  <path
                    className="cls-5"
                    d="M385.83,551.35c-.85-1.65-3.76-2.67-8.45-2.26-5.36.47-5.52,4.15-4.68,5.8.5,1,50.3,100,48.23,228.79a3.49,3.49,0,0,0,3.64,3.32h.05a3.51,3.51,0,0,0,3.7-3.23c1.09-68-7.54-129.88-18.92-167.65C397.06,575.16,386,551.6,385.83,551.35Z"
                  />
                  <path
                    className="cls-5"
                    d="M392.6,585.58c-33.81-9.41-109.34,1.86-112.54,2.35a3.33,3.33,0,0,0-3,3.78,3.59,3.59,0,0,0,3.63,2.72,4.44,4.44,0,0,0,.63,0c.77-.12,77-11.5,109.08-2.57a3.8,3.8,0,0,0,4.64-2.14A3.22,3.22,0,0,0,392.6,585.58Z"
                  />
                  <path
                    className="cls-5"
                    d="M401.23,607.27c-33.81-9.42-109.34,1.86-112.54,2.35a3.34,3.34,0,0,0-3,3.78,3.6,3.6,0,0,0,3.64,2.72,3.31,3.31,0,0,0,.62,0c.77-.11,77-11.5,109.09-2.56a3.79,3.79,0,0,0,4.63-2.14A3.22,3.22,0,0,0,401.23,607.27Z"
                  />
                  <path
                    className="cls-5"
                    d="M399.62,768.29C306.33,770.61,309.13,787,309.13,787h227.6S531.43,765,399.62,768.29Z"
                  />
                  <path
                    className="cls-6"
                    d="M315.93,790.51c-2,.06-5.83,1.7-5.76,3.51,0,.91,6.82,73-19.57,190.46h4.92c39.34-102.12,34-190.93,32.64-193C327.11,790,318,790.48,315.93,790.51Z"
                  />
                  <path
                    className="cls-6"
                    d="M464.25,794c.07-1.81-3.72-3.45-5.76-3.51s-11.18-.53-12.23,1c-1.38,2-6.7,90.83,32.64,193h4.92C457.43,867,464.22,794.93,464.25,794Z"
                  />
                  <path
                    className="cls-7"
                    d="M525.66,794c.07-1.81-3.72-3.45-5.76-3.51s-11.18-.53-12.23,1c-1.38,2-6.7,90.83,32.63,193h4.93C518.84,867,525.63,794.93,525.66,794Z"
                  />
                  <path
                    className="cls-7"
                    d="M382.75,790.51c-2,.06-5.83,1.7-5.76,3.51,0,.91,6.82,73-19.57,190.46h4.92c39.34-102.12,34-190.93,32.64-193C393.93,790,384.82,790.48,382.75,790.51Z"
                  />
                  <path
                    className="cls-6"
                    d="M538,787H308.11a3.51,3.51,0,1,0,0,7H538a3.51,3.51,0,0,0,0-7Z"
                  />
                </g>
                <g id="t_Chaise_portable">
                  <path
                    className="cls-5"
                    d="M1246.34,616.3c-.71-1.41-3.19-2.27-7.18-1.93-4.56.4-4.7,3.53-4,4.93.43.84,42.76,85,41,194.49a3,3,0,0,0,3.09,2.82h0a3,3,0,0,0,3.14-2.74c.93-57.85-6.41-110.41-16.08-142.51C1255.89,636.54,1246.45,616.51,1246.34,616.3Z"
                  />
                  <path
                    className="cls-5"
                    d="M1340.75,616.3c-.72-1.41-3.19-2.27-7.18-1.93-4.56.4-4.7,3.53-4,4.93.43.84,42.76,85,41,194.49a3,3,0,0,0,3.09,2.82h0a3,3,0,0,0,3.14-2.74c.93-57.85-6.41-110.41-16.08-142.51C1350.3,636.54,1340.86,616.51,1340.75,616.3Z"
                  />
                  <path
                    className="cls-5"
                    d="M1346.51,645.39c-28.74-8-93,1.59-95.67,2a2.84,2.84,0,0,0-2.57,3.21,3.06,3.06,0,0,0,3.1,2.32,3.23,3.23,0,0,0,.53,0c.65-.1,65.43-9.77,92.72-2.18a3.22,3.22,0,0,0,3.94-1.82A2.74,2.74,0,0,0,1346.51,645.39Z"
                  />
                  <path
                    className="cls-5"
                    d="M1353.84,663.83c-28.74-8-92.94,1.59-95.66,2a2.84,2.84,0,0,0-2.57,3.21,3.06,3.06,0,0,0,3.09,2.32,4.9,4.9,0,0,0,.54,0c.65-.1,65.42-9.78,92.72-2.18a3.24,3.24,0,0,0,3.94-1.82A2.74,2.74,0,0,0,1353.84,663.83Z"
                  />
                  <path
                    className="cls-5"
                    d="M1352.47,800.71c-79.29,2-76.92,15.9-76.92,15.9H1469S1464.52,797.92,1352.47,800.71Z"
                  />
                  <path
                    className="cls-6"
                    d="M1281.34,819.6c-1.74,0-5,1.44-4.9,3,0,.77,5.79,62-16.64,161.9H1264c33.43-86.8,28.91-162.3,27.74-164C1290.83,819.14,1283.09,819.57,1281.34,819.6Z"
                  />
                  <path
                    className="cls-6"
                    d="M1407.41,822.58c.06-1.54-3.16-2.93-4.9-3s-9.49-.46-10.39.86c-1.17,1.72-5.69,77.22,27.74,164h4.19C1401.62,884.62,1407.38,823.35,1407.41,822.58Z"
                  />
                  <path
                    className="cls-7"
                    d="M1459.62,822.58c.05-1.54-3.17-2.93-4.91-3s-9.49-.46-10.39.86c-1.17,1.72-5.69,77.22,27.74,164h4.19C1453.82,884.62,1459.59,823.35,1459.62,822.58Z"
                  />
                  <path
                    className="cls-7"
                    d="M1338.14,819.6c-1.74,0-5,1.44-4.9,3,0,.77,5.79,62-16.64,161.9h4.19c33.43-86.8,28.92-162.3,27.74-164C1347.63,819.14,1339.89,819.57,1338.14,819.6Z"
                  />
                  <path
                    className="cls-6"
                    d="M1470.12,816.61H1274.68a3,3,0,0,0,0,6h195.44a3,3,0,1,0,0-6Z"
                  />
                </g>
                <g id="t_Chaise_bleue">
                  <path
                    className="cls-5"
                    d="M1252.55,550c-4.69-.41-7.6.61-8.44,2.26-.13.25-11.24,23.81-23.58,64.77-11.37,37.77-20,99.6-18.91,167.65a3.52,3.52,0,0,0,3.69,3.23h.06a3.49,3.49,0,0,0,3.64-3.32c-2.08-128.79,47.73-227.81,48.23-228.8C1258.08,554.13,1257.92,550.45,1252.55,550Z"
                  />
                  <path
                    className="cls-5"
                    d="M1141.49,550c-4.69-.41-7.6.61-8.44,2.26-.13.25-11.24,23.81-23.58,64.77-11.38,37.77-20,99.6-18.91,167.65a3.51,3.51,0,0,0,3.69,3.23h0a3.5,3.5,0,0,0,3.65-3.32c-2.08-128.79,47.72-227.81,48.23-228.8C1147,554.13,1146.86,550.45,1141.49,550Z"
                  />
                  <path
                    className="cls-5"
                    d="M1238.82,588.83c-3.2-.49-78.73-11.76-112.54-2.35a3.21,3.21,0,0,0-2.42,4.1,3.79,3.79,0,0,0,4.63,2.14c32.11-8.93,108.32,2.45,109.08,2.56a3.35,3.35,0,0,0,.63.05,3.6,3.6,0,0,0,3.64-2.72A3.34,3.34,0,0,0,1238.82,588.83Z"
                  />
                  <path
                    className="cls-5"
                    d="M1230.18,610.52c-3.2-.49-78.73-11.77-112.54-2.36a3.23,3.23,0,0,0-2.42,4.11,3.8,3.8,0,0,0,4.64,2.14c32.12-8.94,108.31,2.45,109.08,2.56a3.35,3.35,0,0,0,.63,0,3.59,3.59,0,0,0,3.63-2.72A3.32,3.32,0,0,0,1230.18,610.52Z"
                  />
                  <path
                    className="cls-5"
                    d="M1119.26,769.19c-131.82-3.28-137.12,18.71-137.12,18.71h227.61S1212.54,771.5,1119.26,769.19Z"
                  />
                  <path
                    className="cls-6"
                    d="M1208.7,794.92c.07-1.81-3.72-3.45-5.76-3.51s-11.17-.53-12.23,1c-1.38,2-6.69,90.84,32.64,193h4.93C1201.88,867.91,1208.67,795.83,1208.7,794.92Z"
                  />
                  <path
                    className="cls-6"
                    d="M1060.39,791.41c-2,.06-5.83,1.7-5.77,3.51,0,.91,6.82,73-19.57,190.45H1040c39.33-102.11,34-190.92,32.63-193C1071.56,790.88,1062.45,791.38,1060.39,791.41Z"
                  />
                  <path
                    className="cls-7"
                    d="M999,791.41c-2,.06-5.83,1.7-5.77,3.51,0,.91,6.82,73-19.57,190.45h4.93c39.33-102.11,34-190.92,32.64-193C1010.15,790.88,1001,791.38,999,791.41Z"
                  />
                  <path
                    className="cls-7"
                    d="M1141.88,794.92c.07-1.81-3.72-3.45-5.76-3.51s-11.17-.53-12.23,1c-1.38,2-6.69,90.84,32.64,193h4.93C1135.07,867.91,1141.85,795.83,1141.88,794.92Z"
                  />
                  <path
                    className="cls-6"
                    d="M1210.77,787.9H980.85a3.51,3.51,0,0,0,0,7h229.92a3.51,3.51,0,0,0,0-7Z"
                  />
                </g>
                <g id="t_Femme_orange">
                  <path
                    className="cls-8"
                    d="M588.48,969.9l-1.3-.42c-1.18-.37-2.37-.77-3.55-1.15-10.58-3.52-21-7.69-23.59-18.4-2.76-11.35,5.52-43,5.52-43l-29.37-3.17s-2.83,33.13-4.67,43.46c-1,5.51-3.5,9.89-5,14.62-.1.33-.2.66-.29,1a32,32,0,0,0-1.5,8.54,6.81,6.81,0,0,0,3.89,6.28l0,0c4.53,2.49,11.75.58,20.4.2,1.1-.05,2.82,2.09,3.71,2.09H554c8.56.21,7.65,2.77,23.91,4.16,18.54,1.59,25.37-4.09,26.46-6.67C605.32,975.22,597.37,972.74,588.48,969.9Z"
                  />
                  <path
                    className="cls-9"
                    d="M588.48,969.9a51.83,51.83,0,0,1-10.28,2.64,54.11,54.11,0,0,1-17.59-.12l-.56-.1c-12.37-2.32-24.65-8.48-33.49-10.53l-.3,1c0,.17-.09.35-.14.52l-.27,1c-.05.17-.1.35-.14.52-.08.35-.17.7-.25,1,0,.16-.07.31-.1.46-.08.37-.16.74-.22,1.12,0,.21-.08.43-.11.65s0,.29-.07.43l0,.13c0,.23-.05.46-.07.69a4.12,4.12,0,0,0,0,.48l0,.48c0,.16,0,.31,0,.46v.51a4.87,4.87,0,0,0,0,.54c0,.12,0,.25,0,.37a2.34,2.34,0,0,0,0,.26,2.2,2.2,0,0,0,.06.37c0,.16.07.31.11.46a2.24,2.24,0,0,0,.11.34,3.52,3.52,0,0,0,.15.42c0,.09.08.19.13.28l.09.19h0a2.49,2.49,0,0,0,.15.28l0,0s0,0,0,0a2.53,2.53,0,0,0,.21.32c.06.1.13.19.2.29l0,0c.13.16.26.32.39.46l.24.23.33.31c.12.1.23.19.36.28a8.53,8.53,0,0,0,.76.53h0a3.78,3.78,0,0,0,.43.26h0c.16.11.33.2.5.3h0A11.24,11.24,0,0,0,533,979.1h0a72.36,72.36,0,0,0,8.43.35,56.56,56.56,0,0,1,23.6,4.9l.27.12h29.47c7.78-1.64,9-5.68,9.59-7.06C605.32,975.22,597.36,972.74,588.48,969.9Z"
                  />
                  <polygon
                    className="cls-9"
                    points="527.73 976.41 528.22 977.34 528.23 977.35 528.23 977.35 528.55 977.95 529.52 979.77 529.53 979.77 532.04 984.47 541.47 984.47 541.47 982.3 541.47 980.63 541.47 979.45 541.47 978.57 540.93 978.49 527.73 976.41"
                  />
                  <path
                    className="cls-10"
                    d="M627.17,699.66c-13.55-19.21-159.07-19.87-159.07-19.87L373,688.85s-16.94,76.84,21.46,81.64,122-14.41,148-16.81,21.47-10.8,6.78,32.42-21.31,154.3-21.31,154.3a81.61,81.61,0,0,0,11.17,2,67.07,67.07,0,0,0,20.83-1.46s34.49-74.4,63.86-148.84S627.17,699.66,627.17,699.66Z"
                  />
                  <path
                    className="cls-11"
                    d="M570.15,969.9l-1.29-.42c-1.18-.37-2.37-.77-3.56-1.15-10.58-3.52-21-7.69-23.59-18.4-2.75-11.35,5.53-43,5.53-43l-29.37-3.17s-2.83,33.13-4.68,43.46c-1,5.51-3.49,9.89-5,14.62q-.17.5-.3,1a32.84,32.84,0,0,0-1.5,8.54,6.82,6.82,0,0,0,3.9,6.28l0,0c4.52,2.49,11.75.58,20.39.2,1.11-.05,2.82,2.09,3.71,2.09h1.23c8.55.21,7.65,2.77,23.91,4.16,18.53,1.59,25.36-4.09,26.45-6.67C587,975.22,579,972.74,570.15,969.9Z"
                  />
                  <path
                    className="cls-12"
                    d="M608,707.31c-13.56-18.6-159.07-19.24-159.07-19.24l-89.17,7.53s-22.47,73,15.55,80.32c50.34,9.64,123.39-8.58,149.37-10.91s20.34-6.58,5.65,35.28-16.75,140.5-16.75,140.5,3.34,3.26,13.36,4.07a75,75,0,0,0,14.56-.25s29.75-79.34,59.12-151.43S608,707.31,608,707.31Z"
                  />
                  <path
                    className="cls-13"
                    d="M586.12,976.85a.74.74,0,0,0,0-.14,1.57,1.57,0,0,0-.39-.57l-.13-.14-.27-.24c-.14-.1-.29-.22-.46-.33s-.45-.28-.7-.42l-.4-.21c-.27-.15-.57-.3-.88-.44l-.49-.22-.52-.22c-.34-.15-.71-.3-1.1-.44l-1.2-.46-1.34-.48c-2.41-.85-5.17-1.73-8-2.64a50.84,50.84,0,0,1-9.55,2.52,54.13,54.13,0,0,1-18.89-.1,109.75,109.75,0,0,1-16.58-4.83c-6.3-2.27-12.11-4.59-16.9-5.7-.11.33-.21.66-.29,1a32,32,0,0,0-1.51,8.54c0,.18,0,.36,0,.54s0,.25,0,.37v0a2.24,2.24,0,0,0,0,.24c0,.13,0,.25.07.37s0,.25.08.37l.09.3a.06.06,0,0,0,0,0s0,0,0,0a.08.08,0,0,0,0,0c0,.07.06.16.09.24a2.56,2.56,0,0,0,.12.32s0,0,0,0a5.21,5.21,0,0,0,.24.47c.05.1.11.19.16.28s.13.2.21.3a1.77,1.77,0,0,0,.12.17,2.47,2.47,0,0,0,.21.27l.23.26c.08.08.16.15.23.23l.34.31c.11.1.23.19.35.28a8.53,8.53,0,0,0,.76.53h0a3.78,3.78,0,0,0,.43.26h0c3.06,2,7.24,1.74,12.77,1.84,2,0,4.07.1,6.37.32h0a53.28,53.28,0,0,1,11.94,2.53q2.65.88,5.54,2.17h29.48c.55-.11,1.07-.24,1.56-.38,6.39-1.83,7.49-5.4,8-6.68a1.15,1.15,0,0,0,.07-.35.63.63,0,0,0,0-.19Z"
                  />
                  <polygon
                    className="cls-13"
                    points="509.4 976.41 509.89 977.34 509.9 977.35 509.91 977.35 513.72 984.47 523.15 984.47 523.15 978.57 522.61 978.49 509.4 976.41"
                  />
                  <path
                    className="cls-11"
                    d="M479.47,451c0-10.75.85-22.17.85-22.17L444,421.63l-2.16-.42c.1,28.18-1.28,34.74-6.05,35.69-.16,0,7.21,14.65,18.48,17.72,12,3.28,27.91-5,27.75-5.07C480,468.59,479.44,460,479.47,451Z"
                  />
                  <path
                    className="cls-14"
                    d="M479.47,451c0-10.75.85-22.17.85-22.17L444,421.63C448.43,431.9,459.16,450.42,479.47,451Z"
                  />
                  <path
                    className="cls-6"
                    d="M507,502.31c-1.76-3-9-.47-8.12,2.94l13.39,54.3s3.76-22.34,0-38.66C510.91,515.17,510.26,508,507,502.31Z"
                  />
                  <g id="t_fo_Tête">
                    <path
                      id="t_fo_Cheveux"
                      className="cls-15"
                      d="M481.86,337.87c-6.09-4.89-14.92-4.28-20.61-3.94a9.55,9.55,0,0,1,4.34-2.07c-3.52-.52-11.4,3-11.4,3s-29.82-15.27-43.63,23.89c0,0,2.38-3,5.65-6.32-8,22.53.08,56.61,25.23,62.67C457.79,419,544.23,388,481.86,337.87Z"
                    />
                    <path
                      id="t_fo_Base_cheveux"
                      className="cls-15"
                      d="M490.26,351.82a51.84,51.84,0,0,0-21.53-8.14c-38.23-5.48-43.46,32.56-41.63,42.82,2.55,14.37,13.19,31.19,13.19,31.19l53.38-3.76,3.48-11.21C510.54,369.53,498.56,357.42,490.26,351.82Z"
                    />
                    <path
                      id="t_fo_Visage"
                      className="cls-11"
                      d="M463.44,358.13C432.77,359.91,439,380,439,409.87S487.1,439,487.1,439c12.49-1,17.86-51.26,15.42-61.24S494.11,356.36,463.44,358.13Z"
                    />
                    <path
                      id="t_fo_Mèche"
                      className="cls-15"
                      d="M441.74,363.71A57.14,57.14,0,0,1,423,397.48s8.76,5.4,28.94.22,33.34-40.3,33.34-40.3C475.4,340.69,441.74,363.71,441.74,363.71Z"
                    />
                    <path
                      id="t_fo_Mèche2"
                      className="cls-15"
                      d="M482.06,360.25s9.82,7.84,12.22,15.46,3.47,23.3,8,22.77c0,0,9.91-23.86-1.23-37.36C489.28,346.81,482.06,360.25,482.06,360.25Z"
                    />
                    <path
                      id="t_fo_Bouche"
                      className="cls-16"
                      d="M476.42,420.87s.89,3.8,10.35,3.21c0,0,7.94-.49,7.7-4.67C494.47,419.41,486.77,416.44,476.42,420.87Z"
                    />
                  </g>
                  <path
                    className="cls-5"
                    d="M435.83,456.9c-1.42-.84-17.27,22.62-32.53,51.55-13.83,26.22-27.17,56.93-28.86,78.06a41.26,41.26,0,0,0,.44,11.29c.06.32.14.66.21,1,9,37.87-27.11,93.37-19.58,114.27,2.59,7.19,10.54,9.05,21.19,7.8a110.51,110.51,0,0,0,18.5-4.16c17.68-5.36,37.91-14.43,53.69-21.28,33.14-14.36,33.4-3.28,43.95-12.42.06,0,9-3.91,9-4,10.12-9.23-6.17-23.64,13.3-117.48,6.64-32-35.44-100.63-35.44-100.63S476.09,480.8,435.83,456.9Z"
                  />
                  <path
                    className="cls-6"
                    d="M461.77,619.54c15.89-93.38-51.3-82.42-60.24-91.87-13.38,25.37-25.19,42.79-27.09,58.84a34.78,34.78,0,0,0,.44,11.29c.06.32.14.66.21,1,9,37.87-27.11,93.37-19.58,114.27,2.59,7.19,10.54,9.05,21.19,7.8,2.75-1.2,9.47-2.59,18.5-4.16,17.68-5.36,37.91-14.43,53.69-21.28,33.13-14.35,36.6-4.6,47.13-13.73h0C491.86,659.46,456.9,648.17,461.77,619.54Z"
                  />
                  <path className="cls-6" d="M496,681.67h0Z" />
                  <path className="cls-6" d="M496,681.67Z" />
                  <path className="cls-6" d="M496,681.68h0Z" />
                  <g id="t_fo_Bras">
                    <path
                      id="t_fo_Main_gauche"
                      className="cls-11"
                      d="M614.4,617c-5.78-1.25-19.08,7-19.08,7s-15.57,10.54,1.5,16.32,40.17-4.52,39.67-11S620.17,618.29,614.4,617Z"
                    />
                    <path
                      id="t_fo_Bras_gauche"
                      className="cls-5"
                      d="M530.31,618c-9.79-5.27-10.54-112.21-14.31-129.53s-36.27-27.58-36.27-27.58,6,58.38,13.06,111.47c5.69,43,12.06,82.44,16.43,84.8,9.79,5.27,88.11-5.28,91.88-13.56a9.42,9.42,0,0,0,.71-2.37c1.5-8.37-6-20.22-6-20.22C581.52,618.79,540.1,623.31,530.31,618Z"
                    />
                    <g id="t_fo_Tasse">
                      <path
                        className="cls-17"
                        d="M606,621a109.41,109.41,0,0,0,.7,11.69,14.44,14.44,0,0,0,3.13,6.85h0a15.77,15.77,0,0,0,27.63-10.41V623a16.16,16.16,0,0,0-.13-2Z"
                      />
                      <path
                        className="cls-18"
                        d="M630.55,621a14.38,14.38,0,0,1,.13,2v6.15A15.83,15.83,0,0,1,617,644.79a14.8,14.8,0,0,0,2.12.15,15.84,15.84,0,0,0,15.79-15.79V623a16.16,16.16,0,0,0-.13-2Z"
                      />
                      <rect
                        className="cls-17"
                        x="615.27"
                        y="643.56"
                        width="12.89"
                        height="1.93"
                      />
                    </g>
                    <path
                      id="t_fo_Ombre_bras"
                      className="cls-6"
                      d="M524.28,640.88c-13.87-2.43-15.67-54-21.59-79.07-5.52,43.93,2.16,93,6.53,95.39,9.79,5.27,88.11-5.28,91.88-13.56a9.42,9.42,0,0,0,.71-2.37C581.27,638.38,540,643.63,524.28,640.88Z"
                    />
                  </g>
                  <path
                    className="cls-11"
                    d="M514.36,685.69c-6.78-2.76-21.59.75-21.59.75s-11.79,10.29-3.51,13,13.3-2,20.08,1.76,22.84,1.76,24.1-2S521.14,688.45,514.36,685.69Z"
                  />
                  <path
                    className="cls-5"
                    d="M412.83,606.36c.38-7.15,23-149.46,23-149.46s-54.63.73-64.42,27.09-6.78,119,7.53,146.85,95.64,65.52,104.68,67,14.68-12.42,14.31-13.93S412.45,613.52,412.83,606.36Z"
                  />
                </g>
                <g id="t_Femme_bleue">
                  <path
                    className="cls-19"
                    d="M831.31,547.38c-3-2-16.18-5.5-16.93-4.8s-.79,1.73.84,3.17,7.87,5.08,7,5.49-19.7-9-22.41-5.8,1.54,16.15,8.78,22.38,28.88,8.89,30.24,9.76c11.54,7.37,9.46-11.29,9.46-11.29S834.32,549.38,831.31,547.38Z"
                  />
                  <path
                    className="cls-11"
                    d="M977.28,962.61c-1.46-4.57-4-8.82-5-14.16-1.84-10-4.67-42.1-4.67-42.1l-29.37,3.07s8.28,30.71,5.53,41.71c-2.6,10.37-13,14.41-23.6,17.82l-3.55,1.12-1.3.4c-8.88,2.75-16.84,5.15-15.92,7.28,1.09,2.5,7.92,8,26.46,6.46,16.26-1.35,15.35-3.83,23.91-4H951c.88,0,1.88,0,3,.08,8.65.36,16.6.12,21.12-2.3h0a6.58,6.58,0,0,0,3.89-6.08,30.24,30.24,0,0,0-1.5-8.28C977.48,963.25,977.38,962.93,977.28,962.61Z"
                  />
                  <path
                    className="cls-12"
                    d="M977.28,962.61c-8.83,2-21.12,7.95-33.48,10.21a56.66,56.66,0,0,1-28.44-2.35c-8.88,2.75-16.84,5.15-15.92,7.28,1.09,2.5,7.92,8,26.46,6.46,16.26-1.35,15.35-3.83,23.91-4H951c.9,0,1.89,0,3,0,8.46.24,16.28-.08,21.1-2.24h0a6.58,6.58,0,0,0,3.89-6.08,30.24,30.24,0,0,0-1.5-8.28C977.48,963.25,977.38,962.93,977.28,962.61Z"
                  />
                  <path
                    className="cls-13"
                    d="M885.65,774.36l54.65,147a50,50,0,0,0,16.44-1.51c7.4-2.13,15.89-7.74,15.89-7.74S959.08,771,934.23,741.6,885.65,774.36,885.65,774.36Z"
                  />
                  <g id="t_fb_Jambe">
                    <path
                      className="cls-11"
                      d="M755.55,907.7c-10,5.86-18.15,13-29.21,14.39l-3.71.44c-9.8,1.13-18.93,2-18.43,4.43.57,2.75,6.17,9.64,24.66,11.69s15.4-1.73,28.39,1.45,24.61,4.53,26.24-3.63a32.71,32.71,0,0,0,.2-8.67c-.38-5.27-.54-12.11,2.49-17.28,5.14-8.78,18.45-29,18.45-29l-25.36-2S765.07,902.15,755.55,907.7Z"
                    />
                    <path
                      className="cls-12"
                      d="M754.2,931a52.15,52.15,0,0,1-26.48-8.23l-.09-.19c-9.8,1.13-18.93,2-18.43,4.43.57,2.75,6.17,9.64,24.66,11.69s15.4-1.73,28.39,1.45,24.61,4.53,26.24-3.63a32.71,32.71,0,0,0,.2-8.67C780,927.66,766.74,931.25,754.2,931Z"
                    />
                    <path
                      className="cls-20"
                      d="M1101.78,714.87s-157-53.09-192-41.8S769.6,893.54,769.6,893.54s2.37,3.16,8.85,5.59c6,2.26,20.6,2.11,20.6,2.11s94.89-81.33,106.18-105,15.82-46.32,27.11-44.06,145.72,55.35,176.21,23.72,22.53-72.72,22.53-72.72Z"
                    />
                  </g>
                  <path
                    id="t_fb_Cheveux_longs"
                    className="cls-10"
                    d="M1119,458.77c-24.5-15.06-24.37-34.38-23.35-51.16s-6.68-89-55.75-70.13c0,0-7.88-3.5-11.4-3a9.61,9.61,0,0,1,4.34,2.06c-5.69-.34-13.82.08-20.61,3.94-18,10.22-34.08,101.93-6.43,127.38-2.51-5.18-5.31-14.37-6.68-30.76.21,1.62,3,22.3,11,34,32.65,21.44,95.24,93,94,106.59,0,0,22-37.4,22.43-37.62C1126.56,540.1,1167.22,488.39,1119,458.77Z"
                  />
                  <path
                    className="cls-11"
                    d="M1052.24,423.85l-2.15.43-36.29,7.18s.83,11.42.86,22.18c0,9-.53,17.59-2.6,18.56-.16.07,15.77,8.34,27.75,5.06,11.27-3.07,18.64-17.68,18.48-17.72C1053.52,458.6,1052.14,452,1052.24,423.85Z"
                  />
                  <path
                    className="cls-14"
                    d="M1014.66,453.64c20.3-.58,31-19.1,35.43-29.36l-36.29,7.18S1014.63,442.88,1014.66,453.64Z"
                  />
                  <g id="t_fb_Tête">
                    <path
                      className="cls-10"
                      d="M1025.39,346.32a51.84,51.84,0,0,0-21.53,8.14c-8.3,5.61-20.28,17.71-6.89,50.9l3.48,11.22,53.38,3.75s10.64-16.81,13.2-31.19C1068.85,378.88,1063.62,340.84,1025.39,346.32Z"
                    />
                    <path
                      className="cls-11"
                      d="M1030.68,360.78C1000,359,994,370.42,991.6,380.4s2.93,60.27,15.43,61.25c0,0,48,.79,48.06-29.13S1061.35,362.55,1030.68,360.78Z"
                    />
                    <path
                      className="cls-16"
                      d="M999.65,422.06c-.24,4.17,7.7,4.66,7.7,4.66,9.46.59,10.35-3.21,10.35-3.21C1007.35,419.08,999.65,422.06,999.65,422.06Z"
                    />
                    <path
                      className="cls-10"
                      d="M1052.38,366.35s-33.66-23-43.58-6.31c0,0,13.16,35.11,33.34,40.3s28.94-.22,28.94-.22A57.14,57.14,0,0,1,1052.38,366.35Z"
                    />
                    <path
                      className="cls-10"
                      d="M993,363.77c-11.14,13.49-1.23,37.35-1.23,37.35,4.57.54,5.65-15.15,8.05-22.77s12.21-15.46,12.21-15.46S1004.84,349.45,993,363.77Z"
                    />
                  </g>
                  <path
                    className="cls-21"
                    d="M1119,601.42c4.73-19.86-11.38-58.41-28.21-90.33-15.26-28.92-31.11-52.39-32.53-51.55-40.26,23.9-43.9,4-43.9,4s-36.56,4.86-46.92,22.69c-14.32,24.65-29.92,98.61-45.25,97.52-7-.51-77.82-27.11-77.82-27.11s-11.79,11.05-9.53,24.6c0,0,35,23.41,64.51,38.34,15.63,7.9,29.76,13.43,36.4,11.86,13.47-3.17,34.5-34.38,45.86-52.76l.08-.12c14.5,82.1-5.22,100.8,4.77,109.46,10.54,9.14,25.6-4.35,58.73,10,21.74,9.43,51.9,23.06,72.2,25.43,10.65,1.25,18.6-.6,21.19-7.79C1146.14,694.8,1110,639.3,1119,601.42Z"
                  />
                  <path
                    className="cls-22"
                    d="M1119,601.42c4.73-19.86,4.27-21.37-12.56-53.29-8.94,9.45-65,52.93-59,76.32,7.53,29.12-3.13,29.87-4.14,53.46-.68,15.94,60,39.46,74.08,45.58,10.65,1.25,18.6-.6,21.19-7.79C1146.14,694.8,1110,639.3,1119,601.42Z"
                  />
                  <path
                    className="cls-22"
                    d="M966.15,584.53c-18.45,21.46-21.84,35.77-33.51,36.9-10.77,1-21.85,1.12-33.26-1.82,15.63,7.9,29.76,13.43,36.4,11.86,13.47-3.17,34.5-34.38,45.86-52.76C981.06,574.12,978.12,570.62,966.15,584.53Z"
                  />
                  <g id="t_fb_Bras_tasse">
                    <path
                      className="cls-17"
                      d="M1020.72,622.14c-1.48-.92-4.37-.56-6.45-.12v-3a16.19,16.19,0,0,0-.13-2H982.82a16.19,16.19,0,0,0-.13,2v6.14a15.77,15.77,0,0,0,27.63,10.42h0s7.46-1.84,9.79-4.61S1023.2,623.67,1020.72,622.14Zm-1.66,5.68c-.79,2-4.34,3.14-6.09,3.57a15.56,15.56,0,0,0,1.26-5.19c1.08-1.49,2.79-2.35,4-2.12S1020.06,625.24,1019.06,627.82Z"
                    />
                    <path
                      className="cls-18"
                      d="M989.5,625.14V619a14.38,14.38,0,0,1,.13-2h-4.25a16.16,16.16,0,0,0-.13,2v6.15A15.84,15.84,0,0,0,1001,640.93a14.8,14.8,0,0,0,2.12-.15A15.83,15.83,0,0,1,989.5,625.14Z"
                    />
                    <rect
                      className="cls-17"
                      x="992.02"
                      y="639.55"
                      width="12.89"
                      height="1.93"
                    />
                    <path
                      className="cls-21"
                      d="M1058.29,459.54s12.54,64,12.54,73,40.67,64.76,37.65,67.78-68.28,13.55-72.29,20.08-1.13,20-1.13,20,41.55,4.41,55.4,4.41c26.55,0,63.71-3.91,63.71-3.91,9-24.85-24.1-133.48-43.18-160.09C1097.44,462,1058.29,459.54,1058.29,459.54Z"
                    />
                    <path
                      className="cls-11"
                      d="M1018.11,617.86c-9.6,1.88-14.31,8.47-13.93,11.48s5.46,11.48,12.8,12.24,28.24-4.52,28.24-4.52l-7.34-13.18S1027.72,616,1018.11,617.86Z"
                    />
                  </g>
                </g>
                <path
                  id="t_Table"
                  className="cls-23"
                  d="M1040.1,650.93H507.52a10.35,10.35,0,0,0-10.32,10.33v13.48a10.35,10.35,0,0,0,10.32,10.32H764.86V946c-45.28,1.81-83.83,17.35-99.56,38.48H881.62C866,963.27,828.05,947.83,782.76,946V685.06H1040.1a10.35,10.35,0,0,0,10.33-10.32V661.26A10.36,10.36,0,0,0,1040.1,650.93Z"
                />
                <path
                  id="t_Table_portable"
                  className="cls-23"
                  d="M1793.21,692.91H1437.32a7.93,7.93,0,0,0-7.91,7.91v14a7.93,7.93,0,0,0,7.91,7.91h170.12v228.1c-39.52,1.57-72.67,15-86.42,33.45l188.48.19c-13.64-18.54-46.83-32-86.41-33.63V722.74h170.12a7.93,7.93,0,0,0,7.91-7.91v-14A7.93,7.93,0,0,0,1793.21,692.91Z"
                />
                <g id="t_Feuille2">
                  <path
                    className="cls-24"
                    d="M189,471.08s-62.53,95.5-80.71,97.78,37.51-92.09,37.51-92.09c-12-1.16-30.45,3.12-49.48,9.25-33.91,44-50.8,92.74-56.5,142.09-.66,5.58-1.15,11.18-1.53,16.77-2.37,36,.83,71.94,7.33,106.35,30.8,8.51,70.9,8.45,97.91,2.91,44.33-9.09,25-21.6,1.13-41.9S70.73,697.3,56,689.34s6.82-15.9,36.36-13.63,44.35,31.82,92.09,36.37,84.12-85.26,84.12-85.26c-33,10.24-92.07-8-94.35-19.32s85.25-10.23,98.9-13.65,37.52-30.68,22.73-85.25S189,471.08,189,471.08Z"
                  />
                  <path
                    className="cls-25"
                    d="M38.25,644.88c34.38-31.56,98.27-71.79,215.23-119.14-6.79,2.22-137.29,45.32-213.7,102.37C39.12,633.69,38.63,639.29,38.25,644.88Z"
                  />
                </g>
                <g id="t_Feuille1">
                  <path
                    className="cls-25"
                    d="M52.82,779.75l-.82.89c3.25,13.19,6.91,26.06,10.86,38.5,4.7-5.31,38.54-13.7,38.54-13.7C92.08,793.91,52.82,779.75,52.82,779.75Z"
                  />
                  <path
                    className="cls-25"
                    d="M115.78,816.69s-43.58,8.67-52.09,5q1.23,3.85,2.5,7.63c.36,1.08.71,2.15,1.07,3.2q3.58,10.51,7.36,20.53c8,4.76,25.13,22.31,29.16,24.78,5,3.06,20.18,2.19,32.14-18.24S115.78,816.69,115.78,816.69Z"
                  />
                  <path
                    className="cls-25"
                    d="M67.26,832.54A530.28,530.28,0,0,1,118.32,852a474.84,474.84,0,0,0-52.13-22.62C66.55,830.42,66.9,831.49,67.26,832.54Z"
                  />
                </g>
                <g id="t_Femme_portable">
                  <path
                    className="cls-26"
                    d="M1575.44,966.14C1570.19,961,1549,939.8,1549,939.8h-25.49s-1.45,9.36-5.39,15,0,20.28,0,20.28c20.69-.47,34,9.24,34,9.24h53.68C1600.39,969.05,1580.69,971.33,1575.44,966.14Z"
                  />
                  <path
                    className="cls-26"
                    d="M1518.14,975.1l2.71,9.24h19v-7.82A52.48,52.48,0,0,0,1518.14,975.1Z"
                  />
                  <path
                    className="cls-27"
                    d="M1523.53,939.8H1549l18-105.72-50.61-50.6S1515.4,883.81,1523.53,939.8Z"
                  />
                  <path
                    className="cls-13"
                    d="M1532.28,751.39c-18.62-14-197.26-16.85-197.26-16.85l-16.09,8.53-15.22,8.07s-3.26,46.79,4.86,54.92,163,2.46,174.85,1c2.67-.33,5.36-.53,7.92-.65a136.26,136.26,0,0,1,16.08.27c12.2,50.88,90.32,131.86,91.54,133.13h25.51C1594.54,858.89,1550.9,765.43,1532.28,751.39Z"
                  />
                  <path
                    className="cls-28"
                    d="M1650.89,966.23c-5.25-5.21-26.42-26.43-26.42-26.43H1599s-1.45,9.39-5.39,15.07,0,20.34,0,20.34c20.69-.47,34,9.27,34,9.27h53.68C1675.84,969.14,1656.14,971.43,1650.89,966.23Z"
                  />
                  <path
                    className="cls-28"
                    d="M1593.59,975.1l2.71,9.24h19v-7.82A52.48,52.48,0,0,0,1593.59,975.1Z"
                  />
                  <path
                    className="cls-29"
                    d="M1344.52,753.92l-25.59-10.85-15.22,8.07s-3.26,46.79,4.86,54.92,163,2.46,174.85,1c2.67-.33,5.36-.53,7.92-.65C1340.73,802.22,1344.52,753.92,1344.52,753.92Z"
                  />
                  <path
                    className="cls-30"
                    d="M1330.83,549.15c-.14-6.65.66-18.45.91-22.06,0-.68.08-1.07.08-1.07l-26.74-1.43-5.65-.3v.07c-1,18.62-4.29,32.11-7.09,36.8,15.2,2,33,3.68,49,3.45-2.9-2.28-5.83-4.61-8.75-7.12C1332.21,557.23,1330.88,551.71,1330.83,549.15Z"
                  />
                  <path
                    className="cls-31"
                    d="M1293.84,451.64c-.39-1.53-5.3-18-30.93-13.21,0,0,12.84-1.28,16.22,3.74,0,0-10-4.9-16.48-1.18s-7.83,16.78-7,20.79,7.56,16,12.21,16.16a13.74,13.74,0,0,0,5.33-1.18,60.84,60.84,0,0,0-2.07,6.86c-5.53,23.09,9.45,41.13,17.55,37,5.19-2.67,8.84,6.39,8.84,6.39l43.94-55.22S1312.77,435.43,1293.84,451.64Z"
                  />
                  <path
                    className="cls-32"
                    d="M1305.08,524.59l-5.83-.55.17.31c4.84,8.64,15.19,22.88,31.4,24.8-.13-6.65.67-18.46.92-22.06Z"
                  />
                  <path
                    className="cls-30"
                    d="M1316.1,472.4c-24.24.77-19.74,16.72-20.33,40.34s37.35,24,37.35,24c9.88-.52,15.14-40.1,13.42-48S1340.34,471.63,1316.1,472.4Z"
                  />
                  <path
                    className="cls-31"
                    d="M1333.07,471.78c-20.43-11.92-34.22,4.58-34.22,4.58a45.11,45.11,0,0,1-15.44,26.27s6.8,4.44,22.84.76c4.89-1.13,9.33-4.47,13.13-8.57a88.66,88.66,0,0,1-15.7,18.2c19.25-8.31,27.58-34.58,28.41-37.36,2.26,2.14,6.71,6.78,8,11.24,1.74,6.06,2.27,18.46,5.89,18.13,0,0,8.3-18.63-.21-29.51C1340.07,468.27,1335.6,469.71,1333.07,471.78Z"
                  />
                  <g id="t_fr_Bras2">
                    <path
                      className="cls-32"
                      d="M1474.05,671.67s-8.76-1.19-15.21.27-16.77-2.87-16.77-2.87-37.8-15.84-46.48-22c-18.63-13.27-48.8-93.65-61.33-84.86,0,0-16.33,13.59-9.42,39.15s38.23,62.1,58.2,68.93c14.75,5,53.84,9.68,59,10.29,6.42,1.24,15,5.53,17.32,5.86,2.59.37,8.62-3.13,12.6-2.31,14.5,3,13.91-1.3,13.91-1.3A14.64,14.64,0,0,0,1474.05,671.67Z"
                    />
                    <path
                      className="cls-26"
                      d="M1395.32,642.84c-5.5-.84-27.87-33.81-27.87-33.81s-19.39,49.86-8.07,63,31,2.81,34.27-2.39S1400.82,643.68,1395.32,642.84Z"
                    />
                  </g>
                  <path
                    className="cls-28"
                    d="M1384.74,693.17c-1.53-7.49-3-17.18-4.41-27.43q-.09-.65-.15-1.29c-.88-8.08-.08-17.42.11-26.2,0-1.17,0-2.32,0-3.46,0-14.71-6.9-32.28-6.9-32.28-8.49-24.34-36-41-38.17-42.79s1.23-5.4,0-8.1-9.35,1.48-18.76,2-15.23-4.92-20.73-7.13c-4.21-1.69-4.09,4.22-4.13,8.54h0a18,18,0,0,1-.21,3.27c-.74,3.2-9.79,7.08-9.79,7.08-18.67,7.95-14,35-12.79,42.59a135.83,135.83,0,0,0,4.2,13.83c7,20.59,20.4,56.36,24.29,62.85,5.17,8.65-4.8,59.7-1.57,66s42.57,13.3,48.75,3.32,37.78-12.19,55.88-14.77-3.7-24.38-11.08-31.82C1387.81,705.81,1386.26,700.57,1384.74,693.17Z"
                  />
                  <path
                    className="cls-26"
                    d="M1278.13,619c-2.28-.63-3.93.43-5.08,2.75,7,20.59,20.4,56.36,24.29,62.85,5.17,8.65-4.8,59.7-1.57,66s42.57,13.3,48.75,3.32c-2.31-27.7,44.8-46.59,44.8-46.59-1.51-1.52-3.06-6.76-4.58-14.16C1369.45,681.33,1294,623.39,1278.13,619Z"
                  />
                  <path
                    className="cls-26"
                    d="M1362.84,631c-44.85-40.82-63.37-32.56-64-32.79.83.8,58.24,56.45,81.37,66.29-.42-3.86-1.11-10.07-3.14-15.06C1375.35,645.24,1368,635.68,1362.84,631Z"
                  />
                  <g id="t_fr_Bras1">
                    <path
                      className="cls-30"
                      d="M1489.57,677.12c-1.13-2.27-10.08-12.26-13.73-13.4s-21.93,3.14-21.93,3.14-71.13-2.06-82.17-9.51c-14.38-9.69-48.65-48.78-72.79-69-11.51-9.64-20.72-15-24.39-10.85,0,0-9.88,8.72,1.13,31.75.6,1.29,1.29,2.62,2,4,14.19,26,70.77,77.43,94.26,80s84.1-14.89,84.1-14.89,6.29-1.43,9.39,1.16,15.46,2.66,17.15,4.42c3.16,3.29,10.4,1.67,9.71-.82A43.07,43.07,0,0,0,1489.57,677.12Z"
                    />
                    <path
                      className="cls-28"
                      d="M1374.49,655.44c-9.16-2.65-62.18-59-72.89-68.09a52.84,52.84,0,0,0-22-11.2s-6.48-4-11.4,13.24,58.83,101.08,72,110.26,44.52,8,50.64,3.12,11.76-33.27,12.25-39.08S1383.65,658.1,1374.49,655.44Z"
                    />
                  </g>
                  <path
                    className="cls-26"
                    d="M1303.25,561.1c-7.76-.37-10.66-2.21-11.61-6.1a18,18,0,0,1-.21,3.27c-.74,3.2-9.79,7.08-9.79,7.08s18.84-1.47,24.75,0S1311,561.47,1303.25,561.1Z"
                  />
                  <path
                    className="cls-29"
                    d="M1507.42,806.66c12.2,50.88,90.32,131.86,91.54,133.13h0s-49.22-107.93-60.8-123.21S1507.42,806.66,1507.42,806.66Z"
                  />
                </g>
                <g id="t_Gobelet">
                  <polygon
                    className="cls-17"
                    points="725.76 621.83 727 641.8 727.58 651 752.93 651 753.33 641.8 754.2 621.83 754.62 612.28 725.17 612.28 725.76 621.83"
                  />
                  <polygon
                    className="cls-33"
                    points="725.08 605.83 723.84 612.28 755.94 612.28 755.1 605.83 725.08 605.83"
                  />
                  <polygon
                    className="cls-18"
                    points="727 641.8 753.33 641.8 754.2 621.83 725.76 621.83 727 641.8"
                  />
                </g>
                <g id="t_Smoothie">
                  <path
                    className="cls-18"
                    d="M791.76,613.89c-3.23-1.29-7.1,3.12-10.64.86s-9.46-1.19-9.46-1.19l-.07.17.32,5.21.18,2.89,1.15,18.4.1,1.57.57,9.2h25.35l.4-9.2.07-1.57.8-18.4.13-2.89.17-3.92a12.63,12.63,0,0,0-3.05.7C795.2,616.79,795,615.18,791.76,613.89Z"
                  />
                  <polygon
                    className="cls-34"
                    points="771.59 613.73 771.91 618.94 772.09 621.83 773.24 640.23 773.34 641.8 773.91 651 799.26 651 799.66 641.8 799.73 640.23 800.53 621.83 800.66 618.94 800.83 615.01 800.95 612.28 771.5 612.28 771.59 613.73"
                  />
                  <path
                    className="cls-34"
                    d="M786.36,597.07a14.75,14.75,0,0,0-14.75,14.75c0,.16,0,.31,0,.46H801.1c0-.15,0-.3,0-.46A14.75,14.75,0,0,0,786.36,597.07Z"
                  />
                  <path
                    className="cls-17"
                    d="M792.19,584.23h-.07a7,7,0,0,0-4.76,5.24c-.64,3.64-4.77,58.22-4.84,59l1.28.16c0-.19,4.2-55.37,4.83-58.95a5.71,5.71,0,0,1,3.82-4.22l20.6-3.65-.22-1.27Z"
                  />
                  <polygon
                    className="cls-17"
                    points="772.09 621.83 773.24 640.23 799.73 640.23 800.53 621.83 800.66 618.94 771.91 618.94 772.09 621.83"
                  />
                </g>
                <g id="t_Pot_rouge">
                  <path
                    className="cls-33"
                    d="M693.66,626.65s2.17,3.62-5.07,5.17-7.16,5.84-7.24,6.09c0,0,18.66,6.11,20.75,0S693.66,626.65,693.66,626.65Z"
                  />
                  <polygon
                    className="cls-18"
                    points="681.02 651 702.27 651 705.44 635.63 677.38 635.63 681.02 651"
                  />
                </g>
                <g id="t_Consos_bleues">
                  <polygon
                    className="cls-13"
                    points="1643.96 647.74 1642.72 654.19 1644.05 654.19 1644.64 663.74 1645.89 683.71 1646.46 692.91 1671.81 692.91 1672.21 683.71 1673.08 663.74 1673.5 654.19 1674.83 654.19 1673.98 647.74 1643.96 647.74"
                  />
                  <path
                    className="cls-13"
                    d="M1612.54,668.56s2.17,3.62-5.07,5.17c-3.87.83-5.64,2.45-6.47,3.81h-4.74l3.64,15.37h21.25l3.17-15.37h-3.11C1620.56,672.48,1612.54,668.56,1612.54,668.56Z"
                  />
                </g>
                <path
                  id="t_Portable"
                  className="cls-26"
                  d="M1555.53,622.88a2.34,2.34,0,0,0-3,1.39l-23.27,64h-68a2.33,2.33,0,0,0,0,4.65H1531a2.33,2.33,0,0,0,2.26-2.07l23.63-65A2.32,2.32,0,0,0,1555.53,622.88Z"
                />
              </g>
            </g>
          </g>
        </svg>
        <div className="step1_2">
          <img className="clip_image_step1" src={ClipImageStep1}></img>
          <img className="image1_step1" src={Image1Step1}></img>
          <img className="image2_step1" src={Image2Step1}></img>
          <img className="image1_step2" src={Image1Step2}></img>
        </div>
      </div>
      <div className="div_comptoir">
        <h5 className="title_comptoir">Au comptoir</h5>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1805.43 990.51">
          <g id="Comptoir_svg" data-name="Comptoir_svg">
            <g id="_Layer_" data-name="&lt;Layer&gt;">
              <g id="Comptoir">
                <path className="cls-1" d="M0,0V990.51H1805.43V0Z" />
                <path
                  id="c_Fond"
                  className="cls-2"
                  d="M1396.8,526.79a495,495,0,0,0-3.23-50q-2.05-17.58-5.45-34.74a393.16,393.16,0,0,0-10.46-41.14c-14.1-45.06-36.45-86.51-68.51-121.76a303.85,303.85,0,0,0-48.22-42.78c-2.89-2.08-5.85-4.12-8.84-6.12-93.17-62-236.91-87.58-446.86-49.06a376.34,376.34,0,0,1-103.33,4.2q-11.61-1.08-23.23-2.8a533.05,533.05,0,0,1-116.93-30.72q-16.37-6.39-32.09-12.33l-.06,0C238.24,29.54,107.7,35.49,0,60V986.34l460.05.45,382.73.37,363,.35,2.21-1.89c70.34-60.5,131.32-164.88,163.83-279.38,2-7.15,4-14.33,5.74-21.54,12-47.9,18.84-97.18,19.26-145.44q0-4.2,0-8.36C1396.83,529.52,1396.82,528.16,1396.8,526.79Z"
                />
                <g id="c_Femme_bleue">
                  <path
                    className="cls-3"
                    d="M1042.12,491.66c0-1.2-1-14.2-20.77-14.88,0,0,9.73,1.16,11.42,5.44,0,0-6.63-5.28-12-3.58s-8.57,11.15-8.6,14.26,3,13.14,6.39,14a10.54,10.54,0,0,0,4.15,0,47.07,47.07,0,0,0-2.66,4.75c-7.9,16.21.25,32.06,6.94,30.31,4.29-1.13,5.5,6.19,5.5,6.19l41.67-33.73S1058.82,482.75,1042.12,491.66Z"
                  />
                  <g id="c_fb_BrasG">
                    <path
                      className="cls-4"
                      d="M1144.35,677.45s12.12-.46,14.15,1.56,1,12.13-2.78,15.42-14.16-9.1-14.16-9.1Z"
                    />
                    <path
                      className="cls-4"
                      d="M1062.67,586s-14.35,7.39-13.44,27.48,28.16,55.3,41.84,63.66c10.84,6.63,52.08,8.43,52.08,8.43l1.2-8.13s-38.53-15.65-43.95-21.67C1088.78,642.87,1073.42,581.57,1062.67,586Z"
                    />
                    <path
                      className="cls-5"
                      d="M1068.41,587.66s6.76,11.79,7.77,14.83c0,0-8.76-.34-12.3,6.4C1063.88,608.89,1064.18,589.35,1068.41,587.66Z"
                    />
                  </g>
                  <path
                    className="cls-5"
                    d="M1066.07,622.79c-.2.55-.43,1.1-.68,1.64-7.06,15.17-28.82,40.46-29.81,57.81-.34,6,.41,13.53,2.87,23.4,12.09,48.64-83.49,7.2-78.09-5.39,10.75-25,25.75-60.75,25.75-60.75,0-.18-.14-25.33,0-35.22V604c0-.46,0-.9,0-1.31v-.48c0-3,0-5.24-.07-5.82,2.74-9.95,8-26.56,8-26.56,7.47-3,20.75-1.23,20.75-1.23.47,0,3.4.27,5.72.53,10,1.12,28.7,7.77,29.23,8.82,0,0,4.4,1.83,5.26,2.19q2.91,1.25,5.13,2.36c6,3,8.33,5.13,8.33,5.13C1061.24,592.32,1071.63,608.06,1066.07,622.79Z"
                  />
                  <path
                    className="cls-6"
                    d="M1036.59,694.35l-9.34,2.45v-.09c-16.18,4.3-59.42-12-59.42-12s-15.67,13.78-13.62,46.81c1,16.12-2.92,18.21,1.82,17.45,13.66-2.19,61.74,0,61.86,0l.56-2.38c1.28-.15,2.37-.29,3.07-.4,2.42-.41,4.77-.72,7-.94a122,122,0,0,1,14.9-.63,1.37,1.37,0,0,0,1.39-1.49C1040.94,702.84,1036.59,694.35,1036.59,694.35Z"
                  />
                  <path
                    className="cls-7"
                    d="M1051.08,567.08c-1.21,4.85-2.08,9.52-1.38,10.9a14.67,14.67,0,0,1-10,5.33c-9.5.93-19.2-14.15-19.2-14.15,3.41-1.77,9.52-10.42,13.06-24.86l1.19.56,20.08,9.44S1052.66,560.82,1051.08,567.08Z"
                  />
                  <path
                    className="cls-3"
                    d="M1061.84,614.18c0-.49-1.25-1.2-3.24-2,.58-5.32,1.31-14.79,1.49-29.62q-2.22-1.11-5.13-2.36c.24,6,.36,19.52-2.6,29.72-7.79-2.55-18.71-5.49-26.19-7.42-.88-5.27-3-16-8-33.57l-5.69-.51s6.88,18.25,6.85,32.37l-1.28-.3c-3.69-.79-5.26,14.69-5.57,15.57-5.58,15.57-19.91,13.67-24.78,14.25s-33.78,60.17-34,70.73,68.54,16.89,85.58,15.88S1062.1,617.09,1061.84,614.18Z"
                  />
                  <path
                    className="cls-4"
                    d="M1054.8,554.3s-2.14,6.52-3.71,12.78c-11.73-3.27-15.3-15.61-16.37-22.22Z"
                  />
                  <path
                    className="cls-7"
                    d="M1057.27,561.21s-28.08-6.5-23.76-23.92,3.6-30,21.7-26.57,19.93,10.91,19.9,17.08S1064.68,562.45,1057.27,561.21Z"
                  />
                  <path
                    className="cls-3"
                    d="M1076.69,517.91c-3-6.32-6.57-6-8.79-4.86-13.19-12.2-26.13-2.23-26.13-2.23A34.26,34.26,0,0,1,1026,527.76s4.31,4.42,16.81,4.32c3.82,0,7.66-1.78,11.15-4.2a67,67,0,0,1-14.63,10.92c15.64-3,26.13-21.11,27.21-23,1.32,2,3.86,6.12,4.07,9.64.29,4.78-1.35,14.07,1.39,14.42C1072,539.83,1081.22,527.38,1076.69,517.91Z"
                  />
                  <g id="c_fb_BrasD">
                    <path
                      className="cls-7"
                      d="M1086.65,690.64l-2.36,8.6s-3.6-.64-9.14-1.75l-.11,0-.58-.11c-3.48-.71-7.67-1.6-12.18-2.63-14.44-3.31-32.12-8.13-40.35-13.34-15.17-9.62-36.67-63.55-37.68-86.06,0-1.19-.07-2.33,0-3.41.16-19.39,9.8-22,9.8-22,3.89-1.61,8.4,5.12,13,15.54,9.74,21.85,20.11,60,26.7,71.36,2.77,4.8,18.42,14.53,32,22.33,4.75,2.73,9.24,5.23,12.84,7.2C1083.42,688.94,1086.65,690.64,1086.65,690.64Z"
                    />
                    <path
                      className="cls-5"
                      d="M1007,585.4c-12.89-3.56-22.84,6.51-22.84,6.51.16-19.39,9.82-22,9.82-22C997.89,568.25,1002.39,575,1007,585.4Z"
                    />
                    <path
                      className="cls-8"
                      d="M1123.66,715.66a40.25,40.25,0,0,0,40.25-40.25h-80.49A40.24,40.24,0,0,0,1123.66,715.66Z"
                    />
                    <path
                      className="cls-9"
                      d="M1129.29,710.77a35.94,35.94,0,0,1-42.85-35.25h13.86A35.92,35.92,0,0,0,1129.29,710.77Z"
                    />
                    <path
                      className="cls-10"
                      d="M1110.42,670.82s-10-15-14.45-14,7.85,7.74,12.29,13.31Z"
                    />
                    <path
                      className="cls-11"
                      d="M1161.22,675.41h-75.14c2.09-1.83,6.6-4.72,14-4.25,0,0,7.63-.8,11.73-3.87s16.38-4.33,23.1.91,14.22,3.87,18.32,4.55C1156.68,673.33,1159.91,673.82,1161.22,675.41Z"
                    />
                    <path
                      className="cls-7"
                      d="M1114.38,699c-4.3,1.78-10.37,8.09-20,4.3a140.12,140.12,0,0,0-19.26-5.79l-.11,0-.58-.11h0l3.79-11.13.33.08c2.22.5,15.17,3.33,21.16,2,6.58-1.52,17.7,6.45,17.7,6.45S1118.67,697.21,1114.38,699Z"
                    />
                    <path
                      className="cls-5"
                      d="M1114.38,699c-4.3,1.78-10.37,8.09-20,4.3a140.12,140.12,0,0,0-19.26-5.79l-.11,0-.58-.11c-3.48-.71-7.67-1.6-12.18-2.63a24.13,24.13,0,0,0,3.43-15.63c4.75,2.73,9.24,5.23,12.84,7.2,2.22.5,15.17,3.33,21.16,2,6.58-1.52,17.7,6.45,17.7,6.45S1118.67,697.21,1114.38,699Z"
                    />
                  </g>
                </g>
                <path
                  id="c_Comptoir2"
                  className="cls-12"
                  d="M828.43,706.24c-5.65,0-10.28,5-10.28,11V974.57c0,6.09,4.63,11,10.28,11H1208c19-16.3,37.24-35.79,54.44-57.8q10.29-13.12,20-27.42c1.39-2,2.76-4.08,4.13-6.14,10.79-16.29,21-33.56,30.63-51.63q4.18-7.89,8.19-16,10.56-21.3,19.84-43.8a3.7,3.7,0,0,0,.16-.4q6.63-16.08,12.51-32.69,7.62-21.43,13.9-43.53Z"
                />
                <g id="c_Femme_jaune">
                  <path
                    className="cls-13"
                    d="M468.42,502.38s1.85-3.8,11.12-2.76,11.89,9.37,12.32,14.92c.34,4.46,3.84,46.93,10.8,68.44a7.07,7.07,0,0,1-7.79,9.14l-21-3.16Z"
                  />
                  <path
                    className="cls-14"
                    d="M478.94,586.53,471,617.43l-22.84,1.12-11.37-17c10.63-8.06,12.13-22.18,12-30.56,0-.08,0-.16,0-.25a49.19,49.19,0,0,0-.54-6.55l16.21-4.94,12.34-3.76a93.74,93.74,0,0,0-.54,21C477.06,584,478.94,586.53,478.94,586.53Z"
                  />
                  <path
                    className="cls-14"
                    d="M502,746.34l-82.88-.1s10.31-55.58,4.59-73.79.28-44.82.28-44.82c8.32-19.78,10.44-38.29,14.15-39.26,2-.53,3.68-1.63,5.67-2,32.56-6.51,59,5.34,59,5.34,7.3,18.35-8.34,32.14-9.1,73.58C493,706,502,746.34,502,746.34Z"
                  />
                  <path
                    className="cls-15"
                    d="M505.25,593c-4-7.35-25.73-7.47-25.73-7.47-2.06,2.49-13.17,10.45-27,10.37s-7.47-9.83-7.47-9.83a8,8,0,0,0-1.48.33,13.09,13.09,0,0,0-6.43,4.89c.09-1.81.14-2.88.14-2.88s-20.25,5.53-49.32,54.86c-.86,1.46-3.31,1.22-9,.11-7.26-1.41-22.09-1.23-44.46-4.51,0,0-.77.55-1,3a36.37,36.37,0,0,1-1,7,279.11,279.11,0,0,0,30.4,11.9c5.54,1.76,11.33,3.4,16.86,4.64a86.65,86.65,0,0,0,14.35,2.15s11.56-4.44,25.08-16.1c-1.11,7.86-1.66,13.49-1.61,14.12a156.18,156.18,0,0,1-.27,18.61s58.72,16,76,7.78c2.85-1.35,4.58-3.37,4.73-6.22,1.69-32,9.19-58,9.92-75.9C508.31,603,507.61,597.38,505.25,593Z"
                  />
                  <path
                    className="cls-16"
                    d="M480.32,628a15.68,15.68,0,0,1,20.31,16c-.7,10.81-1.56,23.42-2.53,41.78-.15,2.85-1.88,4.87-4.73,6.22l-16.82-34.88L480.32,628Z"
                  />
                  <path
                    className="cls-17"
                    d="M506.47,744.66l-8-58.23a4.71,4.71,0,0,0-1-2.29c-10.05-12.66-11.09-52.21-11.11-67.3A5.83,5.83,0,0,0,480.7,611c.22-.68,6.29-19.25,11-24.31l-2.08-.33c-1.16-.18-3.22-.38-3.22-.38S477.71,598.15,473.9,611l-.25,0a173.39,173.39,0,0,1-42.36,0h1.35s6.23-18.91,11-24.59a54.71,54.71,0,0,0-6.29,2c-2.95,4.25-8.44,12.46-11.28,21.92a4.59,4.59,0,0,0-4.18,4.23l-2.34,27.35-3.21,37.47c-1.16,8.29-.87,51.64-.74,66a4.58,4.58,0,0,0,4.52,4.6H502A4.6,4.6,0,0,0,506.47,744.66Z"
                  />
                  <path
                    className="cls-18"
                    d="M379,643.38c-7.19-1.4-22.48-1.51-44.48-4.69a38.22,38.22,0,0,1-5.46-2.17c-4.72-2.36-17.29-3.93-20-1.41s2.82,12.73,14.3,13a75.12,75.12,0,0,1,9.26.76,277,277,0,0,0,30.3,11.86c5.54,1.76,11.33,3.4,16.86,4.64A40.7,40.7,0,0,0,379,643.38Z"
                  />
                  <g id="c_fj_BrasG">
                    <path
                      className="cls-15"
                      d="M401.81,671s25.78,6.8,47,7.4a92.67,92.67,0,0,0,16.75-.8s20.34-11.26,32-38c22.61-51.63-3.15-51.26-3.15-51.26s-18.6,17.85-39.9,66.74c-.74,1.71-3.47,1.93-10.64,2-7.66.06-22.24,3.31-43.05,4.59a11.21,11.21,0,0,0,.11,3.26C401.64,670.29,401.81,671,401.81,671Z"
                    />
                    <path
                      className="cls-19"
                      d="M448.82,678.38a24.3,24.3,0,0,1-4.9-21.32c-7.66.06-22.52,2.51-43.33,3.79v0a44.94,44.94,0,0,1-8.9-1.26c-5.44-1.43-18.92-.31-21.16,2.91s5.75,12.68,17.8,10.48a62,62,0,0,1,13.23-1.27C403.65,672.22,428.5,677.81,448.82,678.38Z"
                    />
                  </g>
                  <g id="c_fj_Tête">
                    <path
                      className="cls-20"
                      d="M465.74,503s9.89-3.33,15.09,1.61,2.26,11.49,2.26,11.49Z"
                    />
                    <path
                      className="cls-13"
                      d="M434.52,522.52s.18-21.8,35.27-19.29a17.15,17.15,0,0,1,14.09,9.16c3.95,7.72,5.67,21.29-7.08,43.06Z"
                    />
                    <path
                      className="cls-21"
                      d="M476.26,576.45c-9.82-5.24-25-5.5-27.46-5.5h-.34l.33-.25c1.63-1.19,8.91-6.56,15.67-11.49l12.34-3.76A93.74,93.74,0,0,0,476.26,576.45Z"
                    />
                    <path
                      className="cls-14"
                      d="M442.7,571.4s34.82,1.59,35.48-20.11,5.59-36.11-16.61-38-26.78,6.22-28.76,13.41S433.66,570.43,442.7,571.4Z"
                    />
                    <path
                      className="cls-13"
                      d="M446.49,521.83s-15.51,9.31-13.85,21.33c0,0-7.14-4.34-5.75-15.61s12.66-18.39,22.2-18.39a109.1,109.1,0,0,1,16.65,1.22Z"
                    />
                    <path
                      className="cls-13"
                      d="M443.61,518.05c-6.18,3.28,19.36,6,20.92,16.44s13.74,14.39,13.74,14.39S493.71,491.51,443.61,518.05Z"
                    />
                    <path
                      className="cls-22"
                      d="M438.53,559.59s.25,2.21,5.62,2.51c0,0,4.52.25,4.66-2.12C448.81,560,444.66,557.79,438.53,559.59Z"
                    />
                    <path
                      className="cls-17"
                      d="M450.81,487.51S439.37,493,430.9,518.08l12.71,0Z"
                    />
                    <path
                      className="cls-15"
                      d="M443.61,518.05s35.87.56,48.25-3.51c0,0-2.34-21.75-11.34-29.14l-29.71,2.11S441.83,509,443.61,518.05Z"
                    />
                  </g>
                </g>
                <rect
                  id="c_Comptoir1"
                  className="cls-12"
                  x="52.41"
                  y="706.24"
                  width="719.53"
                  height="279.39"
                  rx="11.45"
                />
                <path
                  id="c_Sol"
                  className="cls-23"
                  d="M1309.05,984.48H0v6H1309.05a3,3,0,1,0,0-6Z"
                />
                <path
                  id="c_Fond_sombre"
                  className="cls-24"
                  d="M529.65,139.53l-.06,0C238.24,29.54,107.7,35.49,0,60V980.36a11.22,11.22,0,0,0,8.56,4.12,11.2,11.2,0,0,0,8.21-3.69,13.07,13.07,0,0,0,3.41-8.87V151.86H561.74Q545.75,146.07,529.65,139.53Z"
                />
                <g id="c_Ecran_fond2">
                  <rect
                    className="cls-24"
                    x="87.59"
                    y="236.36"
                    width="669.13"
                    height="164.54"
                    rx="8.48"
                  />
                  <path
                    className="cls-25"
                    d="M286.88,270.27H142.08a8.18,8.18,0,1,0,0,16.36h144.8a8.18,8.18,0,1,0,0-16.36Z"
                  />
                  <path
                    className="cls-25"
                    d="M286.88,310.45H142.08a8.18,8.18,0,0,0,0,16.36h144.8a8.18,8.18,0,0,0,0-16.36Z"
                  />
                  <path
                    className="cls-25"
                    d="M286.88,350.63H142.08a8.18,8.18,0,1,0,0,16.36h144.8a8.18,8.18,0,1,0,0-16.36Z"
                  />
                  <path
                    className="cls-25"
                    d="M504.31,270.27H359.51a8.18,8.18,0,1,0,0,16.36h144.8a8.18,8.18,0,0,0,0-16.36Z"
                  />
                  <path
                    className="cls-25"
                    d="M504.31,310.45H359.51a8.18,8.18,0,0,0,0,16.36h144.8a8.18,8.18,0,0,0,0-16.36Z"
                  />
                  <path
                    className="cls-25"
                    d="M504.31,350.63H359.51a8.18,8.18,0,1,0,0,16.36h144.8a8.18,8.18,0,0,0,0-16.36Z"
                  />
                  <rect
                    className="cls-25"
                    x="543.33"
                    y="270.27"
                    width="180.16"
                    height="96.73"
                    rx="12.67"
                  />
                </g>
                <g id="c_Ecran_fond1">
                  <path
                    className="cls-24"
                    d="M1377.66,400.9H808.34c-4,0-7.23-3.81-7.23-8.47V244.83c0-4.65,3.26-8.47,7.23-8.47h452.59c15.41,12.9,34.17,29,48.22,42.78C1341.08,310.45,1365.62,355.84,1377.66,400.9Z"
                  />
                  <rect
                    className="cls-25"
                    x="851.51"
                    y="270.27"
                    width="137.63"
                    height="16.36"
                    rx="7.56"
                  />
                  <rect
                    className="cls-25"
                    x="851.51"
                    y="310.45"
                    width="137.63"
                    height="16.36"
                    rx="7.56"
                  />
                  <rect
                    className="cls-25"
                    x="851.51"
                    y="350.63"
                    width="137.63"
                    height="16.36"
                    rx="7.56"
                  />
                  <rect
                    className="cls-25"
                    x="1037.2"
                    y="270.27"
                    width="137.63"
                    height="16.36"
                    rx="7.56"
                  />
                  <rect
                    className="cls-25"
                    x="1037.2"
                    y="310.45"
                    width="137.63"
                    height="16.36"
                    rx="7.56"
                  />
                  <rect
                    className="cls-25"
                    x="1037.2"
                    y="350.63"
                    width="137.63"
                    height="16.36"
                    rx="7.56"
                  />
                  <rect
                    className="cls-25"
                    x="1213.28"
                    y="270.27"
                    width="57.15"
                    height="96.73"
                    rx="7.13"
                  />
                </g>
                <g id="c_Tablette2">
                  <polygon
                    className="cls-12"
                    points="239.83 658.91 297.18 658.91 306.35 695.91 249.66 695.91 239.83 658.91"
                  />
                  <polygon
                    className="cls-12"
                    points="255.26 670.88 280.49 670.88 290.16 706.71 263.62 706.71 255.26 670.88"
                  />
                  <polygon
                    className="cls-26"
                    points="280.49 670.88 282.2 670.88 292.83 706.71 289.94 706.71 280.49 670.88"
                  />
                  <polygon
                    className="cls-26"
                    points="297.18 658.91 298.18 658.91 307.46 695.91 306.35 695.91 297.18 658.91"
                  />
                </g>
                <g id="c_Tablette1">
                  <polygon
                    className="cls-12"
                    points="831.67 635.75 916.81 635.75 930.43 690.68 846.26 690.68 831.67 635.75"
                  />
                  <polygon
                    className="cls-12"
                    points="854.58 653.52 892.04 653.52 906.39 706.71 866.98 706.71 854.58 653.52"
                  />
                  <polygon
                    className="cls-26"
                    points="892.04 653.52 894.57 653.52 910.35 706.71 906.06 706.71 892.04 653.52"
                  />
                  <polygon
                    className="cls-26"
                    points="916.81 635.75 918.29 635.75 932.07 690.68 930.43 690.68 916.81 635.75"
                  />
                </g>
                <g id="c_Cliente">
                  <path
                    className="cls-19"
                    d="M168.19,979c.43,5.34,8,4.87,16.57,3.81s6.23,1.6,18.2,1.68,16.08-3.91,16.64-5.63c.51-1.52-5.27-2.76-11.45-4.21l-2.34-.56a31.47,31.47,0,0,1-17.6-11.39c-5.19-6.66-9.94-37-9.94-37l-18.71,3.49s10.89,26,12,34.49c.5,3.82-2.22,6.37-2.85,9.72A21.16,21.16,0,0,0,168.19,979Z"
                  />
                  <path
                    className="cls-27"
                    d="M184.7,983.26c3.4-.83,6.29,1.13,18.26,1.21s16.08-3.91,16.64-5.63c.51-1.52-5.27-2.76-11.45-4.21l-.07.11A33.53,33.53,0,0,1,190.53,978c-8-.75-16.27-4-21.81-4.6a21.16,21.16,0,0,0-.53,5.56C168.62,984.32,174.56,985.75,184.7,983.26Z"
                  />
                  <path
                    className="cls-27"
                    d="M184.92,947.54s-4.9,3.24-9.51,4.08c-6.91,1.26-10.12-.14-10.12-.14S132.05,868,133.94,839.8c.05-.68.07-1.4.08-2.16a118.37,118.37,0,0,0-1.86-18.92c-.45-2.75-1-5.64-1.54-8.62-1.33-7-3-14.46-4.8-22.11-.79-3.36-1.63-6.76-2.47-10.15-8.36-33.38-18.57-66.27-18.57-66.27s60-19.59,63.38-1.28c1.31,7,5.64,35.16,3.69,78.16a621.14,621.14,0,0,0,2.43,93A515.21,515.21,0,0,0,184.92,947.54Z"
                  />
                  <path
                    className="cls-28"
                    d="M134,837.64a118.37,118.37,0,0,0-1.86-18.92c-.45-2.75-1-5.64-1.54-8.62-1.33-7-3-14.46-4.8-22.11-.79-3.36-1.63-6.76-2.47-10.15,1.18-10.19,2.14-17.18,2.14-17.18S150.4,794.5,134,837.64Z"
                  />
                  <path
                    className="cls-19"
                    d="M92.51,979c.43,5.34,8,5.34,16.51,4.28s6.28,1.13,18.26,1.21,16.07-3.91,16.64-5.63c.5-1.52-5.27-2.76-11.45-4.21l-2.34-.56c-7-1.72-11.62-6.89-17.6-11.39-5.67-4.27-1.7-24.95-1.7-24.95l-17.6-6.29s2.66,20.81,2.66,32.26c0,3.86-2.22,6.37-2.86,9.72A20.74,20.74,0,0,0,92.51,979Z"
                  />
                  <path
                    className="cls-27"
                    d="M109,983.26c2-.46,6.28,1.13,18.26,1.21s16.07-3.91,16.64-5.63c.5-1.52-5.27-2.76-11.45-4.21l-.08.11A33.51,33.51,0,0,1,114.85,978c-8-.75-16.27-4-21.82-4.6a20.74,20.74,0,0,0-.52,5.56C92.94,984.32,98,985.81,109,983.26Z"
                  />
                  <path
                    className="cls-27"
                    d="M140.92,705S121.4,802.32,118.1,855.26,110.69,952,110.69,952a25.76,25.76,0,0,1-9.15,1.26,33.76,33.76,0,0,1-9.25-1.89S72.94,871.75,79.35,839.87s1.07-61.3-2-87.75c-4.41-37.92,12.56-55.54,24.4-67.56S140.92,705,140.92,705Z"
                  />
                  <path
                    className="cls-13"
                    d="M154.75,526.87c1.94-15.84-3-41.18-34.62-37.13s-41.57,35.11-35.19,48.92-9.18,17.15-14.06,32c-4.2,12.76-5.66,28.61-12.45,35.72-21.88,22.92,21,58.18,46.87,50.74,47.1-13.54,53.16-15.56,51.49-52.56-.86-19-15.61-26.31-6.24-31.8C173.17,559.51,150.36,562.71,154.75,526.87Z"
                  />
                  <path
                    className="cls-18"
                    d="M147.8,567.83a87,87,0,0,0-10.62-1.76c-3.1-9.35-1.42-19.13-1.42-19.13l-23.52-7.16c-1.13,25-3.38,28.13-3.85,28.51a106.85,106.85,0,0,0-15.58,5s15,85.91,8.57,102.3a173.25,173.25,0,0,0-8.9,30.95l70,.87s-1-56.28,2.24-76.19S147.8,567.83,147.8,567.83Z"
                  />
                  <path
                    className="cls-29"
                    d="M264,625.64c-.21-2.45-1-3-1-3-22.37,3.29-37.19,3.1-44.46,4.52-5.7,1.1-8,1.26-9-.12-30.9-43.45-52.77-57.1-52.77-57.1s-2.33-1.39-11.46-2.65c0,0-1.31,16.53-9.8,17.93-14.69,2.42-26.52-11-30-16.45,0,0-16.87,4.26-21.82,9.9-3.55,4.06-3.09,13.76-2,19.86a26.92,26.92,0,0,0,1.07,4.42c1,2.76,5,23,6.79,31.09,0,.2.09.39.13.57.12.54.23,1,.33,1.4a.06.06,0,0,1,0,0c.1.43.19.76.26,1s.09.26.13.39a0,0,0,0,0,0,0,66.87,66.87,0,0,1,3.24,27.12,29.75,29.75,0,0,1-.8,4.34C90.51,681,80.74,704.7,78.72,715.61c1.17,2.46,3.81,4.41,7,6a66.34,66.34,0,0,0,13.49,4.32A127.53,127.53,0,0,0,113,728.08c3,.34,6.21.62,9.48.81l1.37.08c21.08,1,44.69.52,47.76-9.5,1.47-4.81-4.4-33.72-5.19-42.31-1.37-15.09.87-35.75,1.87-51.76,17.3,19.07,35.16,25.93,35.16,25.93a85.59,85.59,0,0,0,14.34-2.16c5.53-1.23,11.33-2.87,16.87-4.63A278.33,278.33,0,0,0,265,632.63,36.32,36.32,0,0,1,264,625.64Z"
                  />
                  <g id="c_cl_Tête">
                    <path
                      className="cls-19"
                      d="M141.9,548.54s-28.16,5.65-31.41-11.94-9.07-28.7,8.76-33.05,22.59,1.71,25.1,7.31S149.14,546.61,141.9,548.54Z"
                    />
                    <path
                      className="cls-13"
                      d="M128.14,499.16s.49,6-8.77,16.08-7.05,28.17-7.05,28.17-15.61-29.33-7.28-38.7S128.14,499.16,128.14,499.16Z"
                    />
                    <path
                      className="cls-13"
                      d="M116.82,491.39s14-4.68,27.88,9c6,5.89,5.08,17.48,1.88,24.21,0,0-4.92-14.41-13.88-17.56S116.82,491.39,116.82,491.39Z"
                    />
                    <path
                      className="cls-22"
                      d="M133.13,539.88s.75,2.09,6.05,1.14c0,0,4.45-.79,4-3.13C143.22,537.89,138.68,536.71,133.13,539.88Z"
                    />
                  </g>
                  <path
                    className="cls-30"
                    d="M138.78,696.66c-4,13.55-6.32,24.69-16.34,32.23-3.27-.19-6.48-.47-9.48-.81a127.53,127.53,0,0,1-13.72-2.19,66.34,66.34,0,0,1-13.49-4.32c-3.22-1.55-5.86-3.5-7-6,2-10.91,11.79-34.66,14.14-46.71a30,30,0,0,0,.47-3.16,78.63,78.63,0,0,0-2.91-28.3,0,0,0,0,1,0,0L90,636a.06.06,0,0,0,0,0c-.08-.29-.2-.78-.33-1.4,0-.18-.08-.37-.13-.57-1.6-7.65-5.81-31.62-6.89-34.75a31.66,31.66,0,0,1-1-4.78L90,586.4s48.33,20.63,59,49.11S144.51,677.23,138.78,696.66Z"
                  />
                  <path
                    className="cls-30"
                    d="M234.62,644.54c-10.7,3.39-22.34,6.36-31.21,6.79,0,0-18.1-7-35.5-26.3-.73-3.29-1.44-8.81,2.54-7.22,5.59,2.24,26.26,28.77,34.08,29.33C210.12,647.54,226,645.65,234.62,644.54Z"
                  />
                  <path
                    className="cls-18"
                    d="M288.48,618.87c-2.67-2.51-15.24-.94-20,1.42a38.59,38.59,0,0,1-5.46,2.16c-22,3.19-37.3,3.3-44.49,4.7a40.65,40.65,0,0,0-.82,22c5.53-1.23,11.33-2.87,16.87-4.63a281.57,281.57,0,0,0,30.3-11.86,73,73,0,0,1,9.26-.76C285.65,631.6,291.15,621.39,288.48,618.87Z"
                  />
                  <g id="c_cl_BrasD">
                    <path
                      className="cls-29"
                      d="M196.44,637S172.62,649,152,653.9a92.9,92.9,0,0,1-16.56,2.66S113.19,649.73,96.24,626c-32.75-45.87-7.47-50.82-7.47-50.82s21.88,13.65,52.78,57.11c1.08,1.52,3.79,1.17,10.82-.25,7.51-1.51,22.45-1.33,43.08-4.36a11.34,11.34,0,0,1,.55,3.21C196.47,636.27,196.44,637,196.44,637Z"
                    />
                    <path
                      className="cls-19"
                      d="M225.32,622.27c-2.85-2.68-16.28-1-21.31,1.51a45,45,0,0,1-8.45,3.07v0c-20.62,3-35.67,3.69-43.18,5.2A24.33,24.33,0,0,1,152,653.9c19.77-4.74,42.94-15.33,44.88-16.22a61.93,61.93,0,0,1,13.21-1.48C222.3,635.87,228.17,625,225.32,622.27Z"
                    />
                  </g>
                </g>
                <path
                  id="c_Fond_etagere"
                  className="cls-24"
                  d="M1396.84,530.9q0,4.15,0,8.36c-.42,48.26-7.29,97.54-19.26,145.44H1183.68c-5.85,0-10.63-5.7-10.63-12.67V489.45c0-7,4.78-12.67,10.63-12.67h209.89a495,495,0,0,1,3.23,50C1396.82,528.16,1396.83,529.52,1396.84,530.9Z"
                />
                <g id="c_Etagere">
                  <path
                    className="cls-31"
                    d="M1360.46,535.7H1266l.64-12.74h-1.72c-.5-5.76-11-4-11.21,0h-2l.82,12.74h-9.31l.64-12.74h-1.72c-.5-5.76-11-4-11.21,0h-2l.82,12.74h-9.31L1221,523h-1.72c-.5-5.76-11-4-11.21,0h-2l.82,12.74h-5.59a3.54,3.54,0,0,0-3.52,3.53v1.54a3.54,3.54,0,0,0,3.52,3.53h159.25a3.54,3.54,0,0,0,3.53-3.53v-1.54A3.54,3.54,0,0,0,1360.46,535.7Z"
                  />
                  <rect
                    className="cls-31"
                    x="1197.69"
                    y="608.89"
                    width="166.3"
                    height="8.6"
                    rx="3.53"
                  />
                  <path
                    className="cls-31"
                    d="M1259.28,587.92c-1-6.82-7.11-5.84-12.55-10.42s-15.64,3.87-23.69,6.69c-5.32,1.85-7.74,8-8.78,12H1206l3.32,12.74H1264l2.6-12.74h-7A44.41,44.41,0,0,0,1259.28,587.92Z"
                  />
                  <path
                    className="cls-31"
                    d="M1334.14,587.92c-1-6.82-7.11-5.84-12.56-10.42s-15.63,3.87-23.69,6.69c-5.31,1.85-7.73,8-8.77,12h-8.28l3.32,12.74h54.72l2.6-12.74h-7A43.42,43.42,0,0,0,1334.14,587.92Z"
                  />
                  <path
                    className="cls-31"
                    d="M1338.88,535.64l2.6-12.74h-7a43.42,43.42,0,0,0-.36-8.23c-1-6.82-7.11-5.84-12.56-10.42s-15.63,3.88-23.69,6.69c-5.31,1.86-7.73,8-8.77,12h-8.28l3.32,12.74Z"
                  />
                  <path
                    className="cls-31"
                    d="M1360.46,661.42H1266l.64-12.74h-1.72c-.5-5.76-11-4-11.21,0h-2l.82,12.74h-9.31l.64-12.74h-1.72c-.5-5.76-11-4-11.21,0h-2l.82,12.74h-9.31l.64-12.74h-1.72c-.5-5.76-11-4-11.21,0h-2l.82,12.74h-5.59a3.54,3.54,0,0,0-3.52,3.53v1.54a3.54,3.54,0,0,0,3.52,3.53h159.25a3.54,3.54,0,0,0,3.53-3.53V665A3.54,3.54,0,0,0,1360.46,661.42Z"
                  />
                  <path
                    className="cls-31"
                    d="M1334.14,640.39c-1-6.82-7.11-5.84-12.56-10.41s-15.63,3.87-23.69,6.68c-5.31,1.86-7.73,8-8.77,12h-8.28l3.32,12.74h54.72l2.6-12.74h-7A43.49,43.49,0,0,0,1334.14,640.39Z"
                  />
                </g>
                <g id="c_Homme">
                  <path
                    className="cls-13"
                    d="M719,787.77a173.33,173.33,0,0,1-13.66,19.54c-15,19-31.38,34.61-34.23,49.39a65.75,65.75,0,0,1-2.64,9.47c-1.19,3.38-2.66,6.94-4.36,10.63-6.37,13.85-15.91,29.36-25.43,43.47C622.24,944.66,606.77,965,606.77,965l-28.38-1.21c1.13-2.85,13.51-36.52,30.07-77.67l20.77-51.61L632,827.7l6.21-15.44,27.94-69.4s62.14-23.54,68.59-8.29C740.05,747.15,735.71,759.47,719,787.77Z"
                  />
                  <path
                    className="cls-13"
                    d="M605.88,960.68s-1.45,23.42-6,23.75c-.61.05-23,.05-23,.05l-28.57-.17s.19-6.88,8.54-8.34,22.32-7.32,27.38-18.36C589.59,946,605.88,960.68,605.88,960.68Z"
                  />
                  <path
                    className="cls-13"
                    d="M671.6,892.94s19.74,12.69,17.82,16.81c-.25.54-11.16,20.08-11.16,20.08L664.19,954.7s-5.92-3.52-3.12-11.52,4.49-23.07-2.68-32.86C650.85,900,671.6,892.94,671.6,892.94Z"
                  />
                  <path
                    className="cls-32"
                    d="M653,571.38c.45-.17,28.06-6.77,31-5.64s4.35,6.93,4.35,6.93l-45,7.74S647.16,573.48,653,571.38Z"
                  />
                  <g id="c_h_Tête">
                    <path
                      className="cls-14"
                      d="M678.64,551.32a15.09,15.09,0,0,0,.74-4.29c.56-18.33,4.73-30.51-14-32.15s-22.62,5.26-24.3,11.33.72,37,8.36,37.82a53.06,53.06,0,0,0,6-.17c.16,2,.44,5.5.76,9.35.61,7.34,1.33,15.94,1.54,17.92l20.76-1,11-13.66S681.74,567.2,678.64,551.32Z"
                    />
                    <path
                      className="cls-13"
                      d="M643.84,524.6s7.28,20.29,11.33,18.26,7.78-3.72,8.8,2.71-3.05,15.22,10.48,12.85,23.59-41.5,18.26-47C677.33,495.52,622.71,505.83,643.84,524.6Z"
                    />
                  </g>
                  <path
                    className="cls-17"
                    d="M736.18,735.06c-7.43,8.77-70.61,6.48-89.12-.92a13.4,13.4,0,0,1-3.26-1.75C632.92,723.68,657.48,716,630,649.66a1,1,0,0,1,0-.1c-17.26-49.13,5.47-63.39,13.44-70.64,0,0,38.58-11.72,59.63-5.2C730.37,582.18,744.16,725.62,736.18,735.06Z"
                  />
                  <path
                    className="cls-32"
                    d="M669.74,702.48c-1.25,9-8.52,31.33-22.68,31.66a13.4,13.4,0,0,1-3.26-1.75C632.92,723.68,657.48,716,630,649.66a1,1,0,0,1,0-.1c4.59-3.15,12-6.73,16.87-1.26C654.26,656.68,671,693.13,669.74,702.48Z"
                  />
                  <path
                    className="cls-33"
                    d="M643.8,732.38s-76.91,47.89-85.62,80.55S661.94,915.24,661.94,915.24s12.34-10.89,14.51-18.87c0,0-50.83-60.91-61.86-74.56-6.77-8.38,100.14-29,113.2-49.34s8.39-37.41,8.39-37.41Z"
                  />
                  <path
                    id="c_h_Main"
                    className="cls-14"
                    d="M541.26,692.21s-11.79-5.06-15.66-2.66-10.5,11.17-11.3,13.28-1.09,5.16,2.64,4.51,3.95-.63,3.95-.63,6.27-5,7.76-5.05,7.85,2.86,10.9-.62S541.26,692.21,541.26,692.21Z"
                  />
                  <path
                    className="cls-17"
                    d="M643.29,580.41s-11.47,6.15-19.64,26.12c-8.44,20.66-19.65,67-22.73,69s-49.41,9.32-63.21,14.69c0,0-5.41,9.71-.29,13.72s67.17,1.81,70.93.83c31.32-8.11,47.78-69.91,51.51-79.4S643.29,580.41,643.29,580.41Z"
                  />
                  <path
                    className="cls-13"
                    d="M722,961.29V928.57h33.41a2.38,2.38,0,0,0,2.37-2.37v-8.9a2.38,2.38,0,0,0-2.37-2.37H722V809.48a6.31,6.31,0,0,0-6.29-6.29h-6.75a6.32,6.32,0,0,0-6.3,6.29V914.93H669.2a2.38,2.38,0,0,0-2.37,2.37v8.9a2.38,2.38,0,0,0,2.37,2.37h33.41v32.72c-24.67,1.86-45.77,11.71-51.32,23.19H771.94C766.4,973,746.63,963.15,722,961.29Z"
                  />
                  <rect
                    className="cls-17"
                    x="626.65"
                    y="794.08"
                    width="171.25"
                    height="43.54"
                    rx="5.8"
                  />
                </g>
                <g id="c_Feuille2">
                  <path
                    className="cls-34"
                    d="M1147.78,845.63s-40.73-22.81-21.72-53.77c0,0,15.21-19,31.5-23.9,0,0-8.69,46.16,0,47.25s6-52.14,6-52.14,42.9-20.64,59.74-19c0,0-26.61,45.08-17.92,44s38.56-46.71,38.56-46.71,44-8.14,51.06,17.93-4.35,39.1-10.87,40.73-48.34,1.09-47.25,6.52,29.33,14.12,45.08,9.23c0,0-17.38,42.91-40.19,40.74s-29.87-16.29-44-17.38-24.44,2.71-17.38,6.52,31,1.24,42.37,10.94,20.64,15.67-.55,20-59.2,1.63-66.8-14.67Z"
                  />
                  <path
                    className="cls-35"
                    d="M1274.88,767.41s-114.06,36.94-127.1,78.22c0,0,.55,18.46-10.86,39.65h0a76.63,76.63,0,0,0-10.62,36.57h6.56c.11-9.71,1.13-20.88,4.46-29.33v0c0-.08.07-.15.1-.23.31-.7.75-1.69,1.3-2.88l0-.06c1.33-2.59,2.23-4.52,2.79-5.92h0l0,0c4.06-8.33,9.91-19.16,13.81-21.44C1155.39,861.92,1129.86,826.07,1274.88,767.41Z"
                  />
                </g>
                <g id="c_Feuille1">
                  <path
                    className="cls-34"
                    d="M1107.41,880.94s30.91-17.3,16.48-40.79c0,0-11.53-14.42-23.89-18.13,0,0,6.59,35,0,35.85s-4.54-39.56-4.54-39.56-32.55-15.66-45.32-14.42c0,0,20.19,34.2,13.6,33.38s-29.26-35.44-29.26-35.44-33.37-6.18-38.73,13.6,3.3,29.66,8.24,30.9,36.67.83,35.85,4.94-22.25,10.72-34.2,7c0,0,13.19,32.55,30.49,30.9s22.66-12.36,33.37-13.18,18.55,2.06,13.19,4.94-23.49.95-32.14,8.3-15.66,11.89.41,15.19,44.92,1.23,50.68-11.13Z"
                  />
                  <path
                    className="cls-35"
                    d="M1117,921.85h3.65a50.66,50.66,0,0,0-5-10.83c-8.65-16.07-8.24-30.08-8.24-30.08-9.89-31.31-96.41-59.33-96.41-59.33,110,44.5,90.64,71.69,90.64,71.69,3,1.73,7.39,9.93,10.47,16.25,0,0,0,0,0,.05h0c.44,1.07,1.14,2.56,2.17,4.59l0,0,.93,2.06A38.74,38.74,0,0,1,1117,921.85Z"
                  />
                </g>
                <g id="c_Pot_fleurs">
                  <path
                    className="cls-36"
                    d="M1126.64,981.09a66.58,66.58,0,0,0,66.58-66.58H1060.06A66.58,66.58,0,0,0,1126.64,981.09Z"
                  />
                  <path
                    className="cls-37"
                    d="M1143,980.58a66.62,66.62,0,0,1-74.85-66.07h16.54A66.59,66.59,0,0,0,1143,980.58Z"
                  />
                  <path
                    className="cls-36"
                    d="M1193.8,984.48h-135a8.22,8.22,0,0,1,8.22-8.22h118.56a8.22,8.22,0,0,1,8.22,8.22Z"
                  />
                  <rect
                    className="cls-34"
                    x="1057.87"
                    y="914.51"
                    width="136.86"
                    height="2.04"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
        <div className="step3">
          <img className="opacity_counter" src={OpacityCounter}></img>
          <img className="clip_image_step3" src={ClipImageStep3}></img>
          <img className="image1_step3" src={Image1Step3}></img>
          <img className="image2_step3" src={Image2Step3}></img>
        </div>
      </div>
      <div className="container text_animation mb-3">
        <p className="text_step1 text-justify">
          1. Le client de votre établissement scanne le <b>Qr-Code</b> placé sur
          sa table à l'aide de son <b>smartphone</b>.
        </p>
        <p className="text_step2 text-justify">
          2. Il accède ainsi à la <b>carte</b>; il peut la <b>consulter</b> et,
          si vous souhaitez activer l'option "Commande", il peut aussi
          directement <b>commander</b> en ajoutant dans son panier les produits
          qu'il désire. Dans ce cas, le client peut alors choisir de payer en
          ligne grâce à notre solution de paiment sécurisé ou de payer sur
          place.
        </p>
        <p className="text_step3 text-justify">
          3. Vous recevez alors la nouvelle commande sur une <b>tablette</b> au
          niveau du comptoir.
        </p>
      </div>
    </div>
  );
}

function AdvantagesSection() {
  return (
    <section className="section_cards py-4">
      <Container>
        <h4 className="cards_title text-center my-4">
          Des avantages multiples pour tout le monde
        </h4>
        <Row>
          <Col xs={12} md={4}>
            <Card>
              <Card.Body>
                <Card.Title>Pour le restaurateur</Card.Title>
                <ul>
                  <li>
                    <Card.Text className="text-justify">
                      <img src={BirdGoelys} alt="Icône de liste oiseau" />
                      Turnover de tables plus efficace
                    </Card.Text>
                  </li>
                  <li>
                    <Card.Text className="text-justify">
                      <img src={BirdGoelys} alt="Icône de liste oiseau" />
                      Pas d'impression de carte papier ou de désinfection de
                      menu entre chaque client
                    </Card.Text>
                  </li>
                  <li>
                    <Card.Text className="text-justify">
                      <img src={BirdGoelys} alt="Icône de liste oiseau" />
                      Sécurité de paiment
                    </Card.Text>
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={4}>
            <Card>
              <Card.Body>
                <Card.Title>Pour le service</Card.Title>
                <ul>
                  <li>
                    <Card.Text className="text-justify">
                      <img src={BirdGoelys} alt="Icône de liste oiseau" />
                      Moins d'aller-retours
                    </Card.Text>
                  </li>
                  <li>
                    <Card.Text className="text-justify">
                      <img src={BirdGoelys} alt="Icône de liste oiseau" />
                      Plus de temps pour servir les clients et préparer les
                      tables
                    </Card.Text>
                  </li>
                  <li>
                    <Card.Text className="text-justify">
                      <img src={BirdGoelys} alt="Icône de liste oiseau" />
                      Possibilité de modifier le menu en ligne
                    </Card.Text>
                  </li>
                  <li>
                    <Card.Text className="text-justify">
                      <img src={BirdGoelys} alt="Icône de liste oiseau" />
                      Meilleure visibilité sur les tables restant à encaisser
                    </Card.Text>
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={4}>
            <Card>
              <Card.Body>
                <Card.Title>Pour le client</Card.Title>
                <ul>
                  <li>
                    <Card.Text className="text-justify">
                      <img src={BirdGoelys} alt="Icône de liste oiseau" />
                      Consultation de la carte en toute sécurité
                    </Card.Text>
                  </li>
                  <li>
                    <Card.Text className="text-justify">
                      <img src={BirdGoelys} alt="Icône de liste oiseau" />
                      Pas d'attente à la commande
                    </Card.Text>
                  </li>
                  <li>
                    <Card.Text className="text-justify">
                      <img src={BirdGoelys} alt="Icône de liste oiseau" />
                      Pas d'attente à l'addition
                    </Card.Text>
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

function ContactSection() {
  return <section id="contact" className="section_contact"></section>;
}
